'use strict'


//Plugins

import * as THREE from 'three'
import { RGBELoader } from 'three/addons/loaders/RGBELoader.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import Stats from 'three/addons/libs/stats.module.js';
import { RectAreaLightHelper } from 'three/addons/helpers/RectAreaLightHelper.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import * as dat from 'lil-gui'
import Lenis from 'lenis'
import gsap from 'gsap';
import { Connection, LAMPORTS_PER_SOL, PublicKey } from '@solana/web3.js';


//Shader


import background_v from '../static/shaders/background/background_v.glsl'
import background_f from '../static/shaders/background/background_f.glsl'
import lightbox_v from '../static/shaders/lightbox/lightbox_v.glsl'
import lightbox_f from '../static/shaders/lightbox/lightbox_f.glsl'
import glowNoise_v from '../static/shaders/glowingRing/glowNoise_v.glsl'
import glowNoise_f from '../static/shaders/glowingRing/glowNoise_f.glsl'
import { degToRad } from 'three/src/math/MathUtils.js';



// const connection = new Connection("https://api.mainnet-beta.solana.com");
// const walletKey = new PublicKey("");
// //The following returns the balance in LAMPORTS - https://docs.solana.com/terminology#lamport
// const balance = await connection.getBalance(walletKey) 
// //So we convert it to SOL
// const solBalance = balance / LAMPORTS_PER_SOL
// console.log(balance)
// console.log(solBalance)
// const connect = async () => {
//   const wallet = new PublicKey('69riBKpS3VFmMnGyaFp57E25MRV5Q5e2TVUHsPgCf9LT')
//   const programID = new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')
//   const solana = new Connection("https://floral-necessary-crater.solana-mainnet.quiknode.pro/443faf87783d9f7a713d15540db47927f8554a3a/");

//   //get all token accounts in wallet
//   var tokenAccounts = await solana.getParsedTokenAccountsByOwner(wallet,
//     {
//     programId: programID
//     }
//   )
//   const mintAddress = tokenAccounts.value[0].account.data.parsed.info.mint
//   console.log(mintAddress)
//   const tokenInfo = await solana.getParsedAccountInfo(new PublicKey('8wXtPeU6557ETkp9WHFY1n1EcU6NxDvbAggHGsMYiHsB'))
//   console.log(tokenInfo.value.data.parsed)
//   var tokenPrice = await fetch('https://price.jup.ag/v6/price?ids=8wXtPeU6557ETkp9WHFY1n1EcU6NxDvbAggHGsMYiHsB')
//   tokenPrice = await tokenPrice.json()
//   console.log(tokenPrice)
// }

// connect()




class Scene {
  constructor(colors){
    this.clock = new THREE.Clock()
    this.devMode = true
    this.helper = {
      orbitControl: false,
      axes: false,
      stats: false,
      gui: false,
    }
    this.visibility = {
      background: true,
      particles: true,
      ring: true,
      lightbox: true,
    }
    this.renderingIsPaused = false
    this.colors = colors    
    this.isActiveView = 'home'
    this.memeNumber = 0
    this.sceneIsReady = false 
    

    //canvas

    this.canvasSettings = {}
    this.canvas = document.querySelector( '.webgl' )
    this.canvasSettings.dpr = Math.min( window.devicePixelRatio, 2 )
    this.canvasSettings.vw = document.querySelector('body').clientWidth
    this.canvasSettings.vh = window.innerHeight
    this.canvasSettings.aspectRatio = this.canvasSettings.vw / this.canvasSettings.vh
    // console.log(this.canvasSettings)


    //Viewports

    
    //Scenes    


    this.scene = new THREE.Scene()
    this.renderer = new THREE.WebGLRenderer({
          canvas: this.canvas,
          alpha: true,
          antialias: false,  
    })
    this.renderer.setClearColor( this.colors.dark, 1 )
    this.renderer.setSize(this.canvasSettings.vw, this.canvasSettings.vh)
    this.renderer.setPixelRatio(this.canvasSettings.dpr)
    // this.renderer.shadowMap.enabled = true
    // this.renderer.shadowMap.type = THREE.PCFSoftShadowMap
    this.renderer.toneMappingExposure = 0.04
    this.renderer.toneMapping = THREE.ACESFilmicToneMapping


    //Camera


    this.camera = new THREE.PerspectiveCamera( 35, this.canvasSettings.vw / this.canvasSettings.vh, 0.01, 1000 )

    this.camera.position.set( 0.0, 0.0, 2 )
    //camera.lookAt nur ohne orbitControlls möglich
    this.camera.lookAt( 0.0, 0.0, 0.0 )

    this.basicUniforms = {
      uScrollVelocity: new THREE.Uniform(5),
      uTime: new THREE.Uniform( 0 ),
      uResolution: new THREE.Uniform( new THREE.Vector2( this.canvasSettings.vw * this.canvasSettings.dpr, this.canvasSettings.vh * this.canvasSettings.dpr ) ),
    }

    this.ini()
  }
  async ini() {
    this.addEventListeners()
    this.addObjects()
    // this.addLenis()
    await this.loadTextures()
    // console.log('textures')
    await this.addModels()
    // console.log('models')
    await this.loadEnvMap()
    // console.log('env map')
    this.addViews()
    this.scaleObjectToViewport()
    if( this.devMode ) {
      this.addHelper()
    }
    this.tick()
    this.sceneIsReady = true
    // console.log('scene is ready')
    this.loadMemes()
  }
  async loadTextures() {
    this.textures = {
      coin: {diffuse: '', },
      particle:{diffuse:''}
    }
    const textureLoader = new THREE.TextureLoader()

    this.textures.particle.diffuse = await textureLoader.loadAsync('./models/headParticle.png')
    this.particles.material.alphaMap = this.textures.particle.diffuse

    this.textures.coin.diffuse = await textureLoader.loadAsync('./models/diffuse.png')
    this.textures.coin.diffuse.colorSpace = THREE.SRGBColorSpace
    this.textures.coin.diffuse.flipY = false
    
    this.textures.coin.normal = await textureLoader.loadAsync('./models/normal.png')
    this.textures.coin.normal.colorSpace = THREE.SRGBColorSpace
    this.textures.coin.normal.flipY = false

    this.textures.coin.roughness = await textureLoader.loadAsync('./models/roughness.png')
    this.textures.coin.roughness.colorSpace = THREE.SRGBColorSpace
    this.textures.coin.roughness.flipY = false
  }
  async loadMemes() {
    this.memes = []
    const response = await fetch('/memes/memeList.json')
    const memeList = await response.json()

    const textureLoader = new THREE.TextureLoader()
    var texture = await textureLoader.loadAsync(`./memes/${memeList['01']}`)
    // texture.wrapS = THREE.MirroredRepeatWrapping
    // texture.wrapT = THREE.MirroredRepeatWrapping
    this.memes.push(texture)
    var texture = await textureLoader.loadAsync(`./memes/${memeList['02']}`)
    // texture.wrapS = THREE.MirroredRepeatWrapping
    // texture.wrapT = THREE.MirroredRepeatWrapping
    this.memes.push(texture)
    var texture = await textureLoader.loadAsync(`./memes/${memeList['03']}`)
    // texture.wrapS = THREE.MirroredRepeatWrapping
    // texture.wrapT = THREE.MirroredRepeatWrapping
    this.memes.push(texture)
    var texture = await textureLoader.loadAsync(`./memes/${memeList['04']}`)
    // texture.wrapS = THREE.MirroredRepeatWrapping
    // texture.wrapT = THREE.MirroredRepeatWrapping
    this.memes.push(texture)
    var texture = await textureLoader.loadAsync(`./memes/${memeList['05']}`)
    // texture.wrapS = THREE.MirroredRepeatWrapping
    // texture.wrapT = THREE.MirroredRepeatWrapping
    this.memes.push(texture)
    var texture = await textureLoader.loadAsync(`./memes/${memeList['06']}`)
    // texture.wrapS = THREE.MirroredRepeatWrapping
    // texture.wrapT = THREE.MirroredRepeatWrapping
    this.memes.push(texture)
    this.lightboxUniforms.diffuse1.value = this.memes[this.memeNumber]
    // console.log(this.memes[this.memeNumber].source.data.naturalWidth / this.memes[this.memeNumber].source.data.naturalHeight)
    this.lightboxUniforms.diffuse1Ratio.value = this.memes[this.memeNumber].source.data.naturalWidth / this.memes[this.memeNumber].source.data.naturalHeight
    
  // console.log(this.memes)
  }
  addEventListeners() {
    window.addEventListener( 'resize', () => this.onResize() )
    // window.addEventListener('scroll' , (e) => console.log(e))
  }
  async cubeMap() {
    // const loader = new THREE.CubeTextureLoader();
    // this.cubeMap = await loader.loadAsync([
    //     './img/sky-left.jpg',
    //     './img/sky-right.jpg',
    //     './img/sky-top.jpg',
    //     './img/sky-bottom.jpg',
    //     './img/sky-front.jpg',
    //     './img/sky-back.jpg',
    // ])

    // this.scene.environment = this.cubeMap
    // this.scene.background = this.cubeMap
  }
  addObjects() {
    this.background()
    this.particles()
  }
  async addModels() {
    // GLTF loader
    const bakedMaterial = new THREE.MeshPhysicalMaterial({
      // roughness: 0.34,
      metalness: 0.99,    
    })
    const gltfLoader = new GLTFLoader()
    const response =  await gltfLoader.loadAsync('./models/coin.glb')
    this.coin = response.scene.children[0]
    this.coin.material = bakedMaterial
    this.coin.material.map = this.textures.coin.diffuse
    this.coin.material.roughnessMap = this.textures.coin.roughness
    this.coin.material.normalMap = this.textures.coin.normal
    this.coin.scale.set(0.134,0.134,0.134)
    this.coin.position.set(0,0,0)
    this.coin.rotateZ(degToRad(90))
    // console.log(response)
  }
  addViews() {
    this.ring()
    this.lightbox()
  }
  background() {
    this.backgroundUniforms = {
      uColor: new THREE.Uniform( new THREE.Color( this.colors.dark) ),
      uColor2: new THREE.Uniform( new THREE.Color( this.colors.accentHard) ),
      uTime: this.basicUniforms.uTime,
      uResolution: this.basicUniforms.uResolution,
      uScrollVelocity: this.basicUniforms.uScrollVelocity,
      uScale: new THREE.Uniform(31),
      uAmplitude: new THREE.Uniform(0.44),
      uOctaves: new THREE.Uniform(3),
      uLacunarity: new THREE.Uniform(0.19),
      uIntensity: new THREE.Uniform(0.9),
    }

    // uScale: new THREE.Uniform(6.8),
    //   uAmplitude: new THREE.Uniform(4.4),
    //   uOctaves: new THREE.Uniform(3),
    //   uLacunarity: new THREE.Uniform(0.4),
    //   uIntensity: new THREE.Uniform(1.5),


    const geo = new THREE.PlaneGeometry( 1, 1)
    const mat = new THREE.ShaderMaterial({
      vertexShader: background_v,
      fragmentShader: background_f,
      uniforms: this.backgroundUniforms,
      transparent:true
    })
    this.mesh = new THREE.Mesh( geo, mat )
    this.mesh.position.set( 0.0, 0.0, -10.0)
    this.mesh.name = 'background'

    if( this.visibility.background ){ this.scene.add( this.mesh ) }
    
  }
  lightbox() {
    this.lightboxUniforms = {
      uTime: this.basicUniforms.uTime,
      uResolution: this.basicUniforms.uResolution,
      diffuse1: {value: 0},
      diffuse1Ratio: {value: 0}
    }
    this.lightbox = new THREE.Scene()
    const geo = new THREE.PlaneGeometry( 1, 1)
    const mat = new THREE.ShaderMaterial({
      vertexShader: lightbox_v,
      fragmentShader: lightbox_f,
      uniforms: this.lightboxUniforms,
      transparent:true
    })
    const mesh = new THREE.Mesh( geo, mat )
    mesh.name = 'lightbox'
    mesh.position.set( 0.0, 0.0, 0.0)
    this.lightbox.userData.mesh = mesh
    this.lightbox.userData.camera = new THREE.PerspectiveCamera( 25, 1, 0.01, 1000 )
    this.lightbox.userData.camera.position.set( 0.0, 0.0, 2.2)

    if( this.visibility.lightbox ){
      this.lightbox.add(mesh) 
    }
  }
  changeLightboxImage() {
    // console.log(this.memeNumber)
    this.lightboxUniforms.diffuse1.value = this.memes[this.memeNumber]
    this.lightboxUniforms.diffuse1Ratio.value = this.memes[this.memeNumber].source.data.naturalWidth / this.memes[this.memeNumber].source.data.naturalHeight
  }
  particles() {
    this.particleUniforms = {
      uColor: new THREE.Uniform( new THREE.Color( this.colors.accentHard) ),
      uTime: this.basicUniforms.uTime,
      uResolution: this.basicUniforms.uResolution,
    }
    const geo = new THREE.BufferGeometry()
    const particleCount = 60
    const positions = new Float32Array(particleCount * 3)

    for(var i = 0; i < particleCount * 3; i++) {
      positions[i] = (Math.random() - 0.5) * 2
      // i % 3 === 2 ? positions[i] -= 1.5 : ''
    }

    geo.setAttribute('position', new THREE.BufferAttribute(positions, 3))

    // const mat = new THREE.ShaderMaterial({
    //   vertexShader: particle_v,
    //   fragmentShader: particle_f,
    //   uniforms: this.particleUniforms,
    //   transparent: true,
    // })
    const mat = new THREE.PointsMaterial({
      color: this.colors.accentHard
    })
    mat.size = 0.09
    mat.sizeAttenuation = true
    mat.transparent = true
    // alpha map added by texture loader
    // mat.alphaMap = this.textures.particle.diffuse
    mat.depthWrite = false
    mat.blending = THREE.AdditiveBlending

    this.particles = new THREE.Points(geo, mat)
    if( this.visibility.particles ){ this.scene.add( this.particles ) }
  }
  ring() {
    this.ringUniforms = {
      uColor: new THREE.Uniform( new THREE.Color( this.colors.accentHard) ),
      uTime: this.basicUniforms.uTime,
      uResolution: this.basicUniforms.uResolution,
      uInnerSmooth: new THREE.Uniform(0.44),
      uOuterSmooth1: new THREE.Uniform(0.78),
      uOuterSmooth2: new THREE.Uniform(0.9),
      uRingWidth: new THREE.Uniform(0.8),
    }
    this.ring = new THREE.Scene()
    const geo = new THREE.PlaneGeometry( 1, 1)
    const mat = new THREE.ShaderMaterial({
      vertexShader: glowNoise_v,
      fragmentShader: glowNoise_f,
      uniforms: this.ringUniforms,
      transparent:true
    })
    const mesh = new THREE.Mesh( geo, mat )
    mesh.name = 'heroRing'
    mesh.position.set( 0.0, 0.0, 0.0)
    this.ring.userData.mesh = mesh
    this.ring.userData.camera = new THREE.PerspectiveCamera( 25, 1, 0.01, 1000 )
    this.ring.userData.camera.position.set( 0.0, 0.0, 2 )

    const width = 0.03;
    const height = 3;
    const intensity = 3000;
    const color = this.colors.accentHard
    const rectLight1 = new THREE.RectAreaLight( color, intensity, width, height );
    rectLight1.position.set(0.44,0.0,0.0)
    rectLight1.lookAt(0,0,0)
    const rectLight2 = new THREE.RectAreaLight( color, intensity, width, height );
    rectLight2.position.set(-0.44,0.0,0.0)
    rectLight2.lookAt(0,0,0)
    const rectLight3 = new THREE.RectAreaLight( color, intensity, width, height );
    rectLight3.position.set(0.0, 0.44,0.0)
    rectLight3.lookAt(0,0,0)
    const rectLight4 = new THREE.RectAreaLight( color, intensity, width, height );
    rectLight4.position.set(0.0, -0.44,0.0)
    rectLight4.lookAt(0,0,0)
    
    this.renderer.toneMappingExposure = 0.74
    this.ring.environment = this.envMap

    if( this.visibility.ring ){
      this.ring.add(mesh, this.coin, rectLight1, rectLight2, rectLight3, rectLight4) 
      // this.ring.add( new RectAreaLightHelper( rectLight1 ) );
      // this.ring.add( new RectAreaLightHelper( rectLight2 ) );
    }

  }
  loadEnvMap() {
    return new Promise((resolve, reject) => {
      this.envMap = new RGBELoader()
        .setPath('./img/')
        .load('1k_small_size.hdr',  ( texture ) => {
  
            texture.mapping = THREE.EquirectangularReflectionMapping;
            // this.scene.environment = texture
            // this.ring.environment = texture
            // this.scene.background = texture
            resolve()
        })
    })
  }
  addOrbitControls() {
    this.orbitControls = new OrbitControls( this.camera, this.canvas )
    this.orbitControls = new OrbitControls( this.ring.userData.camera, this.canvas )
    // this.orbitControls.target.y = 1
    // this.orbitControls.update()
    //Don't forget to update orbitControls in tick when usind damping
    this.orbitControls.enableDamping = true
  }
  addAxes() {
    const axesHelper = new THREE.AxesHelper( 1 )
    this.scene.add( axesHelper )
  }
  addHelper() {
    if( this.helper.orbitControl ) { this.addOrbitControls() }
    if( this.helper.axes ) { this.addAxes() }
    if( this.helper.gui ) { this.lilGui() }
    if( this.helper.stats ) {
      this.stats = new Stats()
      document.body.appendChild( this.stats.dom )
    }
  }
  tick() {
    //framerate lock
    const multiplier = this.clock.getElapsedTime()
    
    //Update objects
    this.basicUniforms.uTime.value = multiplier
    this.coin.rotation.z += 0.004

    //Update frame
    this.renderer.setScissorTest( false )
    this.renderer.clear()
    this.renderer.setScissorTest( true )
    //enables transparent scissor
    this.renderer.autoClearColor = false;
    //background
    this.renderer.setViewport(0, 0, this.canvasSettings.vw, this.canvasSettings.vh)
    this.renderer.setScissor(0, 0, this.canvasSettings.vw, this.canvasSettings.vh)
    this.renderer.render( this.scene, this.camera )
    //views


    // set the viewport

    if(window.location.hash === '') {
      var rect = document.querySelector('.vb-hero')
      if(rect !== null) {
        rect = rect.getBoundingClientRect()
        const width = rect.right - rect.left;
        const height = rect.bottom - rect.top;
        const left = rect.left;
        const bottom = this.renderer.domElement.clientHeight - rect.bottom;
    
        this.renderer.setViewport( left, bottom, width, height );
        this.renderer.setScissor( left, bottom, width, height );
        this.renderer.render( this.ring, this.ring.userData.camera)
      }
    }
    // console.log(window.location.hash)
    if(window.location.hash === '#memes') {
      const rect = document.querySelector('.vb-memes').getBoundingClientRect()

      const width = rect.right - rect.left;
      const height = rect.bottom - rect.top;
      const left = rect.left;
      const bottom = this.renderer.domElement.clientHeight - rect.bottom;
  
      this.renderer.setViewport( left, bottom, width, height );
      this.renderer.setScissor( left, bottom, width, height );
      this.renderer.render( this.lightbox, this.lightbox.userData.camera)
    }



    //Update helper


    if( this.devMode && this.helper.stats ) { this.stats.update() }
    if( this.helper.orbitControl ) { this.orbitControls.update() }


    //Request new frame


    if( !this.renderingIsPaused ) { window.requestAnimationFrame( () => this.tick() ) }
  }
  play() {
    this.renderingIsPaused = false
    this.tick()
  }
  stop() {
    this.renderingIsPaused = true
  }
  scaleObjectToViewport() {

    const scale = ( mesh, multiplier, camera ) => {
      const vCamHeight = Math.tan( camera.fov / 2 * Math.PI / 180 ) * ( camera.position.z - mesh.position.z ) * 2
      mesh.scale.y = vCamHeight * multiplier
      mesh.scale.x = vCamHeight * camera.aspect * multiplier
    }

    scale( this.ring.userData.mesh, 1.0, this.ring.userData.camera )

    var i = 0
    this.scene.children.forEach( child => {
        switch( child.name ) {
          case 'background':
            scale( this.scene.children[i], 1.0, this.camera )
          default:
            break
        }
      i++
    })
  }
  scaleViewportToScene(meshPositionZ, sceneHeight) {
    const distance = ( this.camera.position.z - meshPositionZ )
    // console.log( sceneHeight )
    this.camera.fov = 2 * Math.atan( sceneHeight / ( 2 * distance ) ) * 180 / Math.PI
    this.camera.updateProjectionMatrix()
  }
  onResize() {
    // console.log(this.backgroundUniforms.uResolution)
    this.canvasSettings.vw = document.querySelector('body').clientWidth
    this.canvasSettings.vh = window.innerHeight
    this.canvasSettings.aspectRatio = this.canvasSettings.vw / this.canvasSettings.vh
    
    
    //update uniforms
    this.basicUniforms.uResolution.value.set( this.canvasSettings.vw * this.canvasSettings.dpr, this.canvasSettings.vh * this.canvasSettings.dpr)
    
    
    this.renderer.setSize( this.canvasSettings.vw, this.canvasSettings.vh )
    this.camera.aspect = this.canvasSettings.aspectRatio
    this.camera.updateProjectionMatrix()
    this.scaleObjectToViewport()
    // this.updateCoordSystem()

  }
  lilGui() {
    const gui = new dat.GUI({
      width: 300,
      title: 'UI',
      closeFolders: true
    })
    // gui.close()
    // gui.hide()
    document.querySelector('.lil-gui').style.zIndex = 10000;

    const background = gui.addFolder( 'background' )
    background.add(this.backgroundUniforms.uScale, 'value').min( 0 ).max( 50 ).step( 0.001 ).name( 'scale' )
    background.add(this.backgroundUniforms.uAmplitude, 'value').min( 0 ).max( 20 ).step( 0.001 ).name( 'amplitude' )
    background.add(this.backgroundUniforms.uOctaves, 'value').min( 0 ).max( 12 ).step( 1 ).name( 'octaves' )
    background.add(this.backgroundUniforms.uLacunarity, 'value').min( 0 ).max( 20 ).step( 0.001 ).name( 'lacunarity' )
    background.add(this.backgroundUniforms.uIntensity, 'value').min( 0 ).max( 10 ).step( 0.001 ).name( 'intensity' )

    const ring = gui.addFolder( 'ring' )
    ring.add(this.ringUniforms.uInnerSmooth, 'value').min( 0 ).max( 1.0 ).step( 0.001 ).name( 'innerSmooth' )
    ring.add(this.ringUniforms.uOuterSmooth1, 'value').min( 0 ).max( 1.0 ).step( 0.001 ).name( 'OuterSmooth1' )
    ring.add(this.ringUniforms.uOuterSmooth2, 'value').min( 0 ).max( 1.0 ).step( 0.001 ).name( 'OuterSmooth2' )
    ring.add(this.ringUniforms.uRingWidth, 'value').min( 0 ).max( 1.0 ).step( 0.001 ).name( 'ringWidth' )




    // const hero = gui.addFolder('hero')
    // hero.add(this.camera.position, 'x').min(-10).max(10).step(0.001).name('cameraPosition x')
    // hero.add(this.camera.rotation, 'x').min(-10).max(10).step(0.001).name('cameraRotation x')
    // hero.add(this.camera.position, 'y').min(-10).max(10).step(0.001).name('cameraPosition y')
    // hero.add(this.camera.position, 'z').min(-10).max(10).step(0.001).name('cameraPosition z')
    // hero.add(this.waxMountain.rotation, 'z').min(0).max(3.1415 * 2).step(0.001).name('waxMountainRotation z')
    // hero.add(this.waxMountain.position, 'x').min(-1).max(1).step(0.001).name('waxMountainPosition x')
    // hero.add(this.directionalLight.position, 'x').min(-10).max(10).step(0.001).name('lightPos x')
    // hero.add(this.directionalLight.position, 'y').min(-10).max(10).step(0.001).name('lightPos y')
    // hero.add(this.directionalLight.position, 'z').min(-10).max(10).step(0.001).name('lightPos z')
    // hero.add(this.uniforms.uSpeed, 'value').min(0).max(3).step(0.001).name('Speed')
    // hero.add(this.uniforms.uScale, 'value').min(-10).max(10).step(0.001).name('Scale')
    // hero.add(this.uniforms.uOffset, 'value').min(0).max(1).step(0.001).name('Offset')
    // hero.add(this.uniforms.uMultiplier, 'value').min(0).max(1).step(0.001).name('Multiplier')
    // hero.add(this.uniforms.uAmplitude, 'value').min(0).max(3).step(0.001).name('Amplitude')
    // hero.add(this.uniforms.uFrequency, 'value').min(0).max(3).step(0.001).name('Frequency')
    // hero.add(this.uniforms.uOctaves, 'value').min(0).max(9).step(1).name('Octaves')
    // hero.add(this.uniforms.uLacunarity, 'value').min(0).max(3).step(0.001).name('Lacunarity')
    // hero.add(this.uniforms.uPersistence, 'value').min(0).max(3).step(0.001).name('Persistence')

  
    // cubeTweaks.add(cube.material, 'wireframe')
    // cubeTweaks.add(cube, 'visible')
    // cubeTweaks.addColor(cube.material, 'color')

    // custom values or actions like this:
    // var debugObject = {}
    // debugObject.log = () => {console.log('debug')}
    // cubeTweaks.add(debugObject, 'log')
  } 
}

class Structure {
  constructor() {
    this.stateListenerAdded = false
    this.backBtnIsVisible = false
    this.navBarIsVisible = true
    this.navMenuIsOpen = false
    this.colors = {
      dark: 'rgb(38, 33, 36)',
      light: 'rgb(242, 239, 233)',
      mid: 'rgb(191, 174, 168)',
      accentSoft: 'rgb(242, 165, 148)',
      accentHard: 'rgb(205, 164, 7)',
      accentHardValues: 'rgb(205, 164, 7)'

    }
    //blue, green, yellow, red
    this.accentVariations = ['56, 143, 242', '39, 184, 40', '230, 136, 0', '242, 71, 56']
    this.accentVariationsHex = ['#388ff2', '#27b828', '#e68800', '#f24738']
    this.pages = [
      'home',
      'about',
      'connect',
      'charity',
      'whitepaper',
      'memes'
    ]
    this.footer = `<div class="content">
  <!-- <hr class="blockline">
  <h2>Say Hello</h2> -->
  <!-- <span class="h1 realgregcoin">Real Greg Coin</span> -->
    <ul class="social-bar">
      <li><a class="btn-primary btn-social" href="https://twitter.com/realgregcoin" rel="noopener" target="_blank" title="X">
        <svg xmlns="http://www.w3.org/2000/svg" width="300.1" height="271" viewBox="0 0 300.1 271">
          <path id="path2" d="M236,0h46L181,115,299,271H206.4l-72.5-94.8L50.9,271H4.9l107-123L-1.1,0H93.8l65.5,86.6ZM219.9,244h25.5L80.4,26H53Z" transform="translate(1.1)" fill="#F2EFE9"/>
        </svg>
      </a></li>
      <li><a class="btn-primary btn-social" href="https://t.me/gregcoin69" rel="noopener" target="_blank" title="Telegram">
        <svg xmlns="http://www.w3.org/2000/svg" width="543" height="450" viewBox="0 0 543 450">
          <g id="Artboard" transform="translate(-189 -301)">
            <path id="Path-3" d="M226.328,494.722q218.64-95.258,291.589-125.6C656.772,311.367,685.625,301.335,704.431,301c4.136-.073,13.384.952,19.375,5.813,5.058,4.1,6.45,9.649,7.116,13.541a88.185,88.185,0,0,1,.836,19.683c-7.525,79.062-40.083,270.924-56.648,359.475-7.009,37.469-20.81,50.032-34.17,51.262-29.036,2.672-51.084-19.189-79.207-37.624-44.007-28.847-68.867-46.8-111.583-74.953-49.366-32.531-17.364-50.411,10.769-79.631,7.363-7.647,135.3-124.012,137.772-134.568.31-1.32.6-6.241-2.326-8.84s-7.239-1.71-10.352-1q-6.621,1.5-210.9,139.4-29.932,20.554-54.223,20.029c-17.853-.386-52.194-10.094-77.723-18.393-31.312-10.179-56.2-15.56-54.032-32.846q1.693-13.506,37.2-27.624Z" fill="#F2EFE9" fill-rule="evenodd"/>
          </g>
        </svg>
      </a></li>
      <li><a class="btn-primary btn-social" href="https://www.dextools.io/app/en/solana/pair-explorer/B2FmE2iKFmHkWAroggcvdm5wQ8N15ndQDd9MCAdyZ34e?t=1712798706165" rel="noopener" target="_blank" title="Dextools">
        <svg xmlns="http://www.w3.org/2000/svg" width="754" height="867" viewBox="0 0 754 867">
          <path id="path2" d="M280.395,49.025c-51.649,26.9-93.9,49.672-93.9,50.6.023,2.39,123.959,65.156,128.358,65,2-.067,16.517-6.749,32.256-14.847l28.621-14.721,31.258,16.067,31.256,16.07,51.188-23c77.13-34.659,85.141-38.457,83.885-39.733-1.666-1.693-29.331-16.555-104.388-56.07-36.274-19.1-71.481-37.823-78.24-41.612S377.483-.058,376.356,0s-44.311,22.12-95.961,49.024ZM53.863,166.331.1,194.1V315.989C.1,383.027.8,437.874,1.669,437.874s27.316-11.467,58.783-25.482l57.213-25.482V258.434l27.958,15.232q32.323,17.6,64.676,35.115l36.707,19.871,16.336-7.387q15.369-6.96,30.674-14.056c7.885-3.672,27.241-12.39,43.012-19.377s30.37-14.019,32.44-15.621c2.75-2.128-30.782-20.658-124.025-68.54-70.285-36.093-130.046-65.509-132.8-65.368s-29.206,12.752-58.778,28.028Zm529.148,7.8c-36.618,16.531-66.6,30.717-66.638,31.526s19.926,12.675,44.354,26.367,44.412,25.632,44.412,26.531-21.615,11.37-48.03,23.278-93.194,42.061-148.393,67.014l-184.954,83.6c-46.525,21.032-88.462,39.989-93.193,42.132C35.539,517.6,9.419,529.536,5.832,531.585c-3.607,2.063-4.424,14.048-5.066,74.2L0,677.53l48.08,24.5,48.079,24.5,66.669-30.088C199.5,679.89,229.5,665.484,229.5,664.423s-6.776-5.473-15.054-9.815-25.378-13.954-37.995-21.364-25.2-14.21-27.958-15.112-4.98-2.472-4.935-3.5,29.4-14.968,65.236-30.991c69.6-31.117,122.858-55.1,237.2-106.809q76.757-34.626,153.468-69.271c44.891-20.327,97.151-44.022,116.077-52.694l34.41-15.767.765-72.561.769-72.558-48.765-25.03c-26.822-13.765-49.748-24.994-50.95-24.953s-32.141,13.6-68.756,30.13ZM736.883,435.9c-7.186,3.51-21.38,10.082-31.542,14.6s-29.446,13.222-42.852,19.339l-24.374,11.117-.556,63.7c-.307,35.035-1.6,63.545-2.867,63.36-2.885-.429-48.567-23.857-94.487-48.463C507.062,541.8,504.98,541.1,497.192,544.954c-4.5,2.231-31.413,14.3-59.8,26.825s-52.541,23.587-53.677,24.589,56,31.967,126.97,68.819l129.029,67,55.119-28.513c30.312-15.68,56.088-29.983,57.275-31.782,2.672-4.045,2.443-242.93-.232-242.607-1.058.127-7.806,3.1-14.992,6.614ZM431.656,716.293q-14.338,6.161-28.674,12.346c-28.857,12.487-23.2,12.9-57.532-4.189-22.865-11.382-32.721-14.894-37-13.189-3.209,1.278-30.826,13.7-61.376,27.61s-56.6,25.285-57.9,25.285c-12.817,0,8.491,12.731,90.714,54.207L376.319,867l40.572-20.03c22.315-11.017,67.323-33.078,100.021-49.024s59.042-29.413,58.549-29.921-27.893-14.574-60.883-31.262L454.6,706.425Z" transform="translate(0 0)" fill="#F2EFE9" fill-rule="evenodd"/>
        </svg>
      </a></li>
      <li><a class="btn-primary btn-social" href="https://dexscreener.com/solana/B2FmE2iKFmHkWAroggcvdm5wQ8N15ndQDd9MCAdyZ34e" rel="noopener" target="_blank" title="Dexscreener">
        <svg id="dexscreener_logo" xmlns="http://www.w3.org/2000/svg" width="80" height="95.113" viewBox="0 0 80 95.113">
          <path id="Pfad_27" data-name="Pfad 27" d="M69.537,28.446a66.957,66.957,0,0,0,10.821-5.468,3.741,3.741,0,0,1,.487,3.512,4.069,4.069,0,0,1-1.6,1.733A8.227,8.227,0,0,1,76.326,29.3a11.7,11.7,0,0,1-6.789-.851m.529,12.48L74.1,42.793c-8.247,3.7-10.489,10.572-13.152,17.264-2.658-6.692-4.9-13.563-13.148-17.264l4.039-1.868a1.618,1.618,0,0,0,1.277-1.556c-.37-6.268,1.744-9.039,4.6-10.78a6.077,6.077,0,0,1,6.482,0c2.851,1.74,4.965,4.512,4.6,10.78a1.618,1.618,0,0,0,1.277,1.556ZM60.953,0A44.473,44.473,0,0,1,74.364,2.238,34.677,34.677,0,0,1,85.109,8.2c2.626.073,6.463-2.263,8.244-4.448C90.287,11.8,76.3,21.3,66.611,24.941H66.6a10.805,10.805,0,0,0-11.3,0h-.01C45.609,21.3,31.619,11.8,28.553,3.756,30.334,5.941,34.171,8.276,36.8,8.2A34.677,34.677,0,0,1,47.542,2.238,44.476,44.476,0,0,1,60.953,0M52.369,28.446a66.955,66.955,0,0,1-10.82-5.468,3.742,3.742,0,0,0-.487,3.512,4.073,4.073,0,0,0,1.6,1.733A8.231,8.231,0,0,0,45.58,29.3a11.7,11.7,0,0,0,6.789-.851" transform="translate(-20.953)" fill="#F2EFE9" fill-rule="evenodd"/>
          <path id="Pfad_28" data-name="Pfad 28" d="M62.593,61.529a53.31,53.31,0,0,0,5.291-6.612l.735,1.434a34.185,34.185,0,0,1,3.6,15.3l0,8.728.044,4.525A73.969,73.969,0,0,0,80,117.53l-10.993-9.185-7.778,13.08-8.171-7.971L40,135.412,26.942,113.454l-8.171,7.971-7.778-13.079L0,117.531A73.974,73.974,0,0,0,7.745,84.9l.044-4.525-.005-8.728a34.175,34.175,0,0,1,3.6-15.3l.735-1.434a53.307,53.307,0,0,0,5.291,6.612L16.77,62.9a11.341,11.341,0,0,0-.684,8.487,10.167,10.167,0,0,0,3.223,4.59,11.99,11.99,0,0,0,4.868,2.356,13.4,13.4,0,0,0,3.479.34,30.225,30.225,0,0,0-.4,4.927L16.889,89.81l8,4.648a13.293,13.293,0,0,1,1.82,1.273c6.6,6.138,10.563,24.3,13.289,33.165,2.726-8.869,6.692-27.027,13.29-33.165a13.273,13.273,0,0,1,1.82-1.273l8-4.648L52.742,83.6a30.226,30.226,0,0,0-.4-4.927,13.406,13.406,0,0,0,3.479-.34,11.988,11.988,0,0,0,4.868-2.356,10.166,10.166,0,0,0,3.223-4.59,11.341,11.341,0,0,0-.684-8.487l-.638-1.373Z" transform="translate(0 -40.299)" fill="#F2EFE9" fill-rule="evenodd"/>
        </svg>
      </a></li>
      <li><a class="btn-primary btn-social" href="https://www.pump.fun/zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775" rel="noopener" target="_blank" title="Pump.fun">
        <svg xmlns="http://www.w3.org/2000/svg" width="82.356" height="86.311" viewBox="0 0 82.356 86.311">
          <g id="layer1" transform="translate(-61.215 -51.044)">
            <g id="g1052" transform="translate(44.143 -156.872)">
              <g id="g7651">
                <rect id="rect6703" width="13.108" height="25.582" transform="" fill="#fff"/>
                <path id="path1062" d="M56.915,247.538,43.259,234.33l.858-.968c5.32-6,16.9-18.016,18.263-18.951a21.826,21.826,0,0,1,12.843-4.1c8.091-.016,13.307,3.8,15.722,11.494,2.152,6.859,1.348,13.838-2.208,19.139a21.16,21.16,0,0,0-1.659,2.717,12.819,12.819,0,0,1-1.884,2.084c-1.036,1.012-4.654,4.8-8.038,8.425s-6.251,6.582-6.369,6.58-6.361-5.948-13.871-13.213Z" fill="#fff"/>
                <path id="path1060" d="M73.508,263.848l-3.115-3.158,2.591-2.715c1.009-1.057,4.484-4.744,7.746-8.17s5.93-6.3,5.93-6.391a26.793,26.793,0,0,1,1.578-2.514c3.381-5.042,4.146-11.678,2.1-18.2-1.308-4.169-3.877-7.614-6.852-9.192-.679-.36-1.1-.662-.931-.67.845-.043,4.88,2.523,6.829,4.344a22.4,22.4,0,0,1,6.294,20.7A19.354,19.354,0,0,1,90.6,247.891c-5.865,6.437-15.766,16.856-15.992,16.856a3.572,3.572,0,0,1-1.1-.9Z" fill="#e5e5e5"/>
                <path id="path1058" d="M35.075,285.3c-5.812-1.306-11.946-5.843-14.262-10.549-1.1-2.232-1.194-2.719-1.182-6.025a23.03,23.03,0,0,1,2.476-10.852c.925-1.885,2.547-3.87,6.993-8.562,3.184-3.359,7.144-7.552,8.8-9.319l3.012-3.212L54.8,250.148c13.811,13.3,13.881,13.375,13.233,14.2-2.341,2.968-15.892,16.887-17.621,18.1A20.326,20.326,0,0,1,35.075,285.3ZM33.2,280.644c.322-.6.179-.924-.827-1.872-2.154-2.03-3.485-.663-1.392,1.43C32.339,281.564,32.669,281.63,33.2,280.644Zm-3.988-10.038a22.387,22.387,0,0,0-.5-4.69c-.64-.7-1.428.15-1.676,1.8-.522,3.482.585,7.935,1.853,7.449.429-.165.49-1.017.326-4.563Zm2.015-8.347c1.011-.949,1.126-2.1.246-2.436-.414-.159-.967.153-1.671.94-1.712,1.916-.441,3.25,1.425,1.5Z" fill="#c6c6c6"/>
                <path id="path1056" d="M36.407,289.991c-6.789-1.828-12.249-7.332-14.547-14.665-.97-3.1-.9-3.255.354-.755a16.516,16.516,0,0,0,3.443,4.378c7.007,6.6,17.281,7.741,24.456,2.708a125.941,125.941,0,0,0,9.652-9.556l8.079-8.6h0l4.5,4.13-1.275,1.434c-5.033,5.659-15.662,16.7-17.086,17.741a20.8,20.8,0,0,1-6.912,3.251,30.7,30.7,0,0,1-10.668-.065Z" fill="#d3d3d3"/>
                <path id="path1054" d="M37.7,294.013c-4.929-.734-8.748-2.773-12.916-6.894-5.531-5.47-7.686-10.6-7.709-18.349a23.437,23.437,0,0,1,3.621-13.582c1.723-2.751,2.92-4.138,11.873-13.758.993-1.067,5.292-5.749,9.554-10.4,14.259-15.574,17.219-18.388,21.741-20.671a22.971,22.971,0,0,1,10.979-2.44c4.69,0,6.209.344,10.482,2.374,2.911,1.383,3.768,2.015,6.526,4.813,5.233,5.308,7.568,10.828,7.579,17.918.01,6.5-1.665,11.739-5.112,15.994-.943,1.164-5.139,5.847-9.324,10.407s-9.99,10.907-12.9,14.105c-13.547,14.889-17.018,17.9-22.6,19.6a31.706,31.706,0,0,1-11.793.883Zm9.509-4.068c5.319-1.415,7.486-3.209,19.176-15.872l5.525-5.985-1.142-1.2c-.628-.66-7.564-7.4-15.414-14.978L41.08,238.133l-2.485,2.655c-1.367,1.46-5.1,5.417-8.306,8.793-6.389,6.737-7.653,8.63-8.828,13.226-2.975,11.633,3.912,24.151,14.919,27.115a30.142,30.142,0,0,0,10.827.023Zm33.8-31.964C93.461,244.649,93.8,244.2,95.075,239.313a29.838,29.838,0,0,0-.026-11.994,21.2,21.2,0,0,0-5.828-9.88,19.2,19.2,0,0,0-14.594-5.995,19.772,19.772,0,0,0-12.793,4.269c-1.677,1.28-17.466,17.921-17.733,18.69-.067.193,2.235,2.6,5.115,5.356s8.333,8.03,12.117,11.728c11.828,11.559,13.219,12.866,13.582,12.751.194-.061,2.935-2.877,6.092-6.256Z" fill="#f1f1f1"/>
              </g>
            </g>
          </g>
        </svg>
      </a></li>
      <li><a class="btn-primary btn-social" href="https://www.coingecko.com/de/munze/greg16676935420" rel="noopener" target="_blank" title="Coingecko">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="96" height="96" viewBox="0 0 96 96">
          <defs>
            <clipPath id="clip-path">
              <rect id="Rechteck_68" data-name="Rechteck 68" width="96" height="96" fill="#F2EFE9"/>
            </clipPath>
          </defs>
          <g id="coingecko_logo" clip-path="url(#clip-path)">
            <path id="Pfad_29" data-name="Pfad 29" d="M48.121,0A48,48,0,1,0,95.993,47.788,47.836,47.836,0,0,0,48.121,0ZM42.086,45.647a8.58,8.58,0,1,1,8.519-8.58A8.551,8.551,0,0,1,42.086,45.647Zm6.8,9.276.043-.054.046-.054a15.183,15.183,0,0,0,7.981,2.218,37.264,37.264,0,0,0,8.389-.7A45.678,45.678,0,0,0,73.5,53.792a41,41,0,0,0,4.361-2.077l.027-.017c.874-.528,1.727-1.087,2.564-1.662.183-.131.359-.268.531-.408l.02.023.073.087a30.979,30.979,0,0,1-7.29,4.71,46.419,46.419,0,0,1-8.187,3,25.477,25.477,0,0,1-8.732,1.014c-2.929-.261-6.015-1.295-7.987-3.536Zm21.867-9.276a1.847,1.847,0,1,1,1.857,1.85A1.858,1.858,0,0,1,70.749,45.647Zm-14.6,46.038c-1.84-12.989,9.422-25.71,15.773-32.219,1.441-1.475,3.67-3.509,5.742-5.67,8.243-7.764,9.884-17.04-6.988-21.676-3.2-.933-6.513-2.255-9.871-3.589a7.013,7.013,0,0,0-.365-.883,9.49,9.49,0,0,0-2.079-2.312c-2.192-1.917-6.314-1.866-9.871-1.017a24.678,24.678,0,0,0-11.541-.365C20.634,28.483,18.011,36.5,17.376,46.155c-.864,10.437-1.368,18.214-5.291,27.1A44.187,44.187,0,1,1,92.4,47.808,44.3,44.3,0,0,1,56.148,91.691Z" fill="#F2EFE9"/>
            <path id="Pfad_30" data-name="Pfad 30" d="M48.078,37.144a5.993,5.993,0,1,1-5.992-6.034A6.012,6.012,0,0,1,48.078,37.144Z" fill="#F2EFE9"/>
          </g>
        </svg>
      </a></li>
      <li><a class="btn-primary btn-social" href="https://jup.ag/swap/SOL-zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775" rel="noopener" target="_blank" title="Jupiter">
        <svg xmlns="http://www.w3.org/2000/svg" width="252.229" height="250" viewBox="0 0 252.229 250">
          <g id="logo-grayscale" transform="translate(-2 -3)">
            <path id="Pfad_29" data-name="Pfad 29" d="M26.146,199.614a128.38,128.38,0,0,0,90.786,52.734c-9.257-13.931-22.714-26.748-39.514-36.506S42.827,200.754,26.146,199.614Z" fill="#F2EFE9"/>
            <path id="Pfad_30" data-name="Pfad 30" d="M99.993,176.988c-32.366-18.8-67.4-23.6-92.464-15.13a128.947,128.947,0,0,0,9.529,23.121c21.778-.5,45.556,5.411,67.682,18.262s39.048,30.587,49.4,49.759a129.7,129.7,0,0,0,24.82-3.178C153.9,223.858,132.35,195.8,99.993,176.988Z" fill="#F2EFE9"/>
            <path id="Pfad_31" data-name="Pfad 31" d="M254.229,100.663A128.293,128.293,0,0,0,94.549,7.894c27.7,3.39,58.441,13.787,88.591,31.3S237.573,78.267,254.229,100.663Z" fill="#F2EFE9"/>
            <path id="Pfad_32" data-name="Pfad 32" d="M213.93,162.049c-14.177-23.544-38.463-46.09-68.38-63.47S84.024,71.272,56.573,70.615C32.422,70.043,14.3,77.064,6.856,89.872c-.042.076-.1.148-.148.225-.669,2.4-1.246,4.809-1.771,7.224,10.389-4.1,22.426-6.385,35.811-6.639,29.765-.559,63.076,8.961,93.815,26.82s55.53,42.09,69.783,68.215c6.39,11.771,10.377,23.359,11.957,34.43,1.839-1.644,3.644-3.343,5.394-5.11.046-.08.076-.165.123-.25C229.26,201.966,226.383,182.747,213.93,162.049Z" fill="#F2EFE9"/>
            <path id="Pfad_33" data-name="Pfad 33" d="M122.788,137.754C76.974,111.137,26.346,106.968,2,125.543a127.82,127.82,0,0,0,1.33,17.372,100.851,100.851,0,0,1,22.007-4.076c27.206-2.047,57.2,5.533,84.418,21.354s48.675,38.133,60.377,62.763a100.012,100.012,0,0,1,7.356,21.134,128.877,128.877,0,0,0,15.757-7.444C197.321,206.292,168.616,164.375,122.788,137.754Z" fill="#F2EFE9"/>
            <path id="Pfad_34" data-name="Pfad 34" d="M237.5,122.641c-14.338-23.519-38.837-46.128-68.966-63.622S106.67,31.44,79.13,30.631c-20.994-.606-37.256,4.483-45.688,14.1,35.01-5.932,81.189,4.038,125.949,30.04S235.7,135.954,247.876,169.3C252.05,157.224,248.419,140.577,237.5,122.641Z" fill="#F2EFE9"/>
          </g>
        </svg>
      </a></li>
      <li><a class="btn-primary btn-social" href="https://www.jeetscreener.com/token/zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775" rel="noopener" target="_blank" title="Jeetscreener">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" width="285.75mm" height="232.83078mm" viewBox="0 0 285.75 232.83078" version="1.1" id="svg1" xml:space="preserve"><defs id="defs1"/>
          <g id="layer1" transform="translate(37.877303,-30.718044)">
            <path id="path1" style="fill:#F2EFE9;stroke-width:2.99758" d="M 50.251685 30.718044 L 15.752498 40.40014 L -33.581958 94.99009 C -34.071167 95.379826 -34.496689 95.85108 -34.852165 96.395689 L -37.877303 99.743288 L 105.02612 263.54879 L 247.8727 100.20786 L 196.03865 40.388255 L 159.77368 30.718044 L 50.251685 30.718044 z M 51.900163 42.708527 L 158.20323 42.708527 L 179.28309 48.329372 L 150.98507 69.686725 L 59.148299 69.686725 L 32.008354 48.293199 L 51.900163 42.708527 z M 191.85131 53.868052 L 230.18024 98.098944 L 179.97452 121.37659 L 160.41757 77.589602 L 191.85131 53.868052 z M 19.729517 53.885105 L 49.700297 77.505369 L 30.111829 121.57761 L -19.915609 97.754779 L 19.729517 53.885105 z M 60.967826 81.676691 L 149.10922 81.676691 L 167.74167 123.39662 L 42.325037 123.62555 L 60.967826 81.676691 z M -6.5629353 117.39647 L 28.862293 134.26521 L 72.279797 207.77339 L -6.5629353 117.39647 z M 216.81258 117.5112 L 137.42052 208.2948 L 181.19718 134.02388 L 216.81258 117.5112 z M 166.4725 135.38814 L 105.02922 239.64018 L 43.585942 135.61448 L 166.4725 135.38814 z "/>
            </g>
        </svg>
        </a></li>
        <li><a class="btn-primary btn-social" href="https://holderscan.com/token/zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775" rel="noopener" target="_blank" title="Holderscan">
          <svg width="100%" height="100%" viewBox="0 0 180 172" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
            <g transform="matrix(1,0,0,1,-1150.45,-1668.15)">
                <g transform="matrix(3.77953,0,0,3.77953,778.643,1571.1)">
                    <path id="path1" d="M131.896,70.705C131.687,68.896 130.884,67.472 128.856,65.317C127.18,63.535 126.705,62.993 126.336,62.444C125.863,61.739 125.612,61.086 125.561,60.426L125.521,59.91L125.87,60.147C127.626,61.342 130.347,61.378 132.672,60.238C133.804,59.683 134.172,59.247 134.092,58.557L134.048,58.18L134.554,57.642C135.106,57.056 135.415,56.541 135.567,55.955C135.649,55.637 135.732,55.508 136.09,55.137C136.324,54.895 136.56,54.588 136.616,54.455C136.8,54.015 136.717,53.854 135.872,53.019C135.166,52.321 135.086,52.216 134.78,51.588C134.539,51.093 134.361,50.581 134.122,49.685C133.674,48.009 133.4,47.223 132.989,46.426C132.485,45.448 131.891,44.659 131.028,43.821C128.581,41.445 124.854,40.101 120.714,40.101C119.722,40.101 118.613,40.173 118.199,40.265C118.107,40.285 118.054,40.266 118.054,40.213C118.054,40.081 116.832,38.056 115.961,36.745C114.52,34.575 113.208,32.948 112.52,32.474L112.228,32.273L112.106,32.427C110.11,34.967 109.16,39.981 109.695,45.167C110.076,48.869 111.246,53.038 112.916,56.655C113.112,57.078 113.26,57.437 113.245,57.452C113.198,57.499 112.33,56.759 111.949,56.347C109.964,54.203 108.195,50.937 107.273,47.716C107.156,47.308 107.039,46.949 107.013,46.918C106.893,46.779 106.006,48.296 105.564,49.394C104.941,50.946 104.729,52.097 104.731,53.912C104.732,55.006 104.758,55.368 104.877,56.003C105.199,57.712 105.842,59.221 106.943,60.853C108.025,62.457 109.166,63.814 110.566,65.159L111.371,65.932L110.792,65.641C109.416,64.948 108.174,63.982 106.466,62.274C105.217,61.026 104.253,59.92 103.436,58.798C103.187,58.457 102.958,58.176 102.926,58.175C102.838,58.17 102.927,60.29 103.051,61.141C103.193,62.117 103.534,63.442 103.847,64.241C103.986,64.595 104.093,64.884 104.084,64.884C104.076,64.884 103.855,64.617 103.594,64.29C99.402,59.047 97.626,52.358 98.665,45.721C99.301,41.663 100.988,37.863 103.625,34.55C104.391,33.588 106.212,31.751 107.118,31.027C108.972,29.545 110.791,28.445 112.817,27.582C118.243,25.271 124.354,25.056 129.896,26.982C134.791,28.683 138.977,31.916 141.87,36.23C143.944,39.323 145.208,42.71 145.722,46.555C145.869,47.653 145.887,50.967 145.752,52.073C144.881,59.212 141.157,65.282 135.206,69.263C134.419,69.789 133.09,70.547 132.402,70.861L131.939,71.073L131.896,70.705ZM129.155,40.665C129.67,39.584 129.952,38.436 130.034,37.08C130.079,36.343 130.016,34.948 129.932,34.812C129.838,34.66 127.342,36.027 126.315,36.793C125.639,37.297 124.831,38.093 124.299,38.778L123.847,39.358L124.162,39.442C125.673,39.847 127.275,40.466 128.192,41.002C128.491,41.176 128.759,41.32 128.788,41.323C128.817,41.325 128.982,41.029 129.155,40.665ZM129.026,50.001C127.715,49.617 126.777,48.94 126.379,48.089C126.188,47.681 125.953,46.766 126.022,46.697C126.041,46.678 126.282,46.723 126.557,46.797C128.934,47.436 129.949,48.39 129.77,49.82C129.745,50.023 129.695,50.167 129.651,50.165C129.609,50.163 129.328,50.09 129.026,50.001L129.026,50.001Z" style="fill:rgb(242,239,233);fill-rule:nonzero;"/>
                </g>
            </g>
        </svg>
      </a></li>
    </ul>
    </div>`
    this.routes = {
      "404": {
                template: "/templates/404.html",
                title: "404",
                html: `PAGE NOT FOUND`
            },
      "/": {
          title: "MULTIVERSE OF $GREG",
          html: `<section class="hero">
  <div class="viewbox vb-hero"></div>
  <p class="tagline">The real greg coin</p>
  <h1 class="center">Multiverse of&nbsp;$greg</h1>
</section>
<section class="price">
  <div class="content">
    <div class="price-block">
      <span>USDC</span>
      <span class="greg-usdc">FETCHING DATA</span>
    </div>
    <div class="price-block">
      <span>SOL</span>
      <span class="greg-sol">FETCHING DATA</span>
    </div>
  </div>
</section>
<section class="sitemap">
  <div class="content">
    <hr class="blockline">
    <ul>
      <li>
        <a href="/#about" role="button" data-owner="about" ><span class="h2">About</span><span class="chapter-number p">01</span></a>
      </li>
      <li>
        <a href="/#connect" role="button" data-owner="connect"><span class="h2">let's greg</span><span class="chapter-number p">02</span></a>
      </li>
      <li>
        <a href="/#charity" role="button" data-owner="charity"><span class="h2">Charity</span><span class="chapter-number p">03</span></a>
      </li>
      <li>
        <a href="/#whitepaper" role="button" data-owner="whitepaper"><span class="h2">Whitepaper</span><span class="chapter-number p">04</span></a>
      </li>
      <li>
        <a href="/#memes" role="button" data-owner="memes"><span class="h2">Memes</span><span class="chapter-number p">05</span></a>
      </li>
    </ul>
  </div>
</section>
<section class="say-hi">
  <div class="content">
    <hr class="blockline">
    <h2>Say Hello</h2>
      <ul class="social-bar">
        <li><a class="btn-primary btn-social" href="https://twitter.com/realgregcoin" rel="noopener" target="_blank" title="X">
          <svg xmlns="http://www.w3.org/2000/svg" width="300.1" height="271" viewBox="0 0 300.1 271">
            <path id="path2" d="M236,0h46L181,115,299,271H206.4l-72.5-94.8L50.9,271H4.9l107-123L-1.1,0H93.8l65.5,86.6ZM219.9,244h25.5L80.4,26H53Z" transform="translate(1.1)" fill="#F2EFE9"/>
          </svg>
        </a></li>
        <li><a class="btn-primary btn-social" href="https://t.me/gregcoin69" rel="noopener" target="_blank" title="Telegram">
          <svg xmlns="http://www.w3.org/2000/svg" width="543" height="450" viewBox="0 0 543 450">
            <g id="Artboard" transform="translate(-189 -301)">
              <path id="Path-3" d="M226.328,494.722q218.64-95.258,291.589-125.6C656.772,311.367,685.625,301.335,704.431,301c4.136-.073,13.384.952,19.375,5.813,5.058,4.1,6.45,9.649,7.116,13.541a88.185,88.185,0,0,1,.836,19.683c-7.525,79.062-40.083,270.924-56.648,359.475-7.009,37.469-20.81,50.032-34.17,51.262-29.036,2.672-51.084-19.189-79.207-37.624-44.007-28.847-68.867-46.8-111.583-74.953-49.366-32.531-17.364-50.411,10.769-79.631,7.363-7.647,135.3-124.012,137.772-134.568.31-1.32.6-6.241-2.326-8.84s-7.239-1.71-10.352-1q-6.621,1.5-210.9,139.4-29.932,20.554-54.223,20.029c-17.853-.386-52.194-10.094-77.723-18.393-31.312-10.179-56.2-15.56-54.032-32.846q1.693-13.506,37.2-27.624Z" fill="#F2EFE9" fill-rule="evenodd"/>
            </g>
          </svg>
        </a></li>
        <li><a class="btn-primary btn-social" href="https://www.dextools.io/app/en/solana/pair-explorer/B2FmE2iKFmHkWAroggcvdm5wQ8N15ndQDd9MCAdyZ34e?t=1712798706165" rel="noopener" target="_blank" title="Dextools">
          <svg xmlns="http://www.w3.org/2000/svg" width="754" height="867" viewBox="0 0 754 867">
            <path id="path2" d="M280.395,49.025c-51.649,26.9-93.9,49.672-93.9,50.6.023,2.39,123.959,65.156,128.358,65,2-.067,16.517-6.749,32.256-14.847l28.621-14.721,31.258,16.067,31.256,16.07,51.188-23c77.13-34.659,85.141-38.457,83.885-39.733-1.666-1.693-29.331-16.555-104.388-56.07-36.274-19.1-71.481-37.823-78.24-41.612S377.483-.058,376.356,0s-44.311,22.12-95.961,49.024ZM53.863,166.331.1,194.1V315.989C.1,383.027.8,437.874,1.669,437.874s27.316-11.467,58.783-25.482l57.213-25.482V258.434l27.958,15.232q32.323,17.6,64.676,35.115l36.707,19.871,16.336-7.387q15.369-6.96,30.674-14.056c7.885-3.672,27.241-12.39,43.012-19.377s30.37-14.019,32.44-15.621c2.75-2.128-30.782-20.658-124.025-68.54-70.285-36.093-130.046-65.509-132.8-65.368s-29.206,12.752-58.778,28.028Zm529.148,7.8c-36.618,16.531-66.6,30.717-66.638,31.526s19.926,12.675,44.354,26.367,44.412,25.632,44.412,26.531-21.615,11.37-48.03,23.278-93.194,42.061-148.393,67.014l-184.954,83.6c-46.525,21.032-88.462,39.989-93.193,42.132C35.539,517.6,9.419,529.536,5.832,531.585c-3.607,2.063-4.424,14.048-5.066,74.2L0,677.53l48.08,24.5,48.079,24.5,66.669-30.088C199.5,679.89,229.5,665.484,229.5,664.423s-6.776-5.473-15.054-9.815-25.378-13.954-37.995-21.364-25.2-14.21-27.958-15.112-4.98-2.472-4.935-3.5,29.4-14.968,65.236-30.991c69.6-31.117,122.858-55.1,237.2-106.809q76.757-34.626,153.468-69.271c44.891-20.327,97.151-44.022,116.077-52.694l34.41-15.767.765-72.561.769-72.558-48.765-25.03c-26.822-13.765-49.748-24.994-50.95-24.953s-32.141,13.6-68.756,30.13ZM736.883,435.9c-7.186,3.51-21.38,10.082-31.542,14.6s-29.446,13.222-42.852,19.339l-24.374,11.117-.556,63.7c-.307,35.035-1.6,63.545-2.867,63.36-2.885-.429-48.567-23.857-94.487-48.463C507.062,541.8,504.98,541.1,497.192,544.954c-4.5,2.231-31.413,14.3-59.8,26.825s-52.541,23.587-53.677,24.589,56,31.967,126.97,68.819l129.029,67,55.119-28.513c30.312-15.68,56.088-29.983,57.275-31.782,2.672-4.045,2.443-242.93-.232-242.607-1.058.127-7.806,3.1-14.992,6.614ZM431.656,716.293q-14.338,6.161-28.674,12.346c-28.857,12.487-23.2,12.9-57.532-4.189-22.865-11.382-32.721-14.894-37-13.189-3.209,1.278-30.826,13.7-61.376,27.61s-56.6,25.285-57.9,25.285c-12.817,0,8.491,12.731,90.714,54.207L376.319,867l40.572-20.03c22.315-11.017,67.323-33.078,100.021-49.024s59.042-29.413,58.549-29.921-27.893-14.574-60.883-31.262L454.6,706.425Z" transform="translate(0 0)" fill="#F2EFE9" fill-rule="evenodd"/>
          </svg>
        </a></li>
        <li><a class="btn-primary btn-social" href="https://dexscreener.com/solana/B2FmE2iKFmHkWAroggcvdm5wQ8N15ndQDd9MCAdyZ34e" rel="noopener" target="_blank" title="Dexscreener">
          <svg id="dexscreener_logo" xmlns="http://www.w3.org/2000/svg" width="80" height="95.113" viewBox="0 0 80 95.113">
            <path id="Pfad_27" data-name="Pfad 27" d="M69.537,28.446a66.957,66.957,0,0,0,10.821-5.468,3.741,3.741,0,0,1,.487,3.512,4.069,4.069,0,0,1-1.6,1.733A8.227,8.227,0,0,1,76.326,29.3a11.7,11.7,0,0,1-6.789-.851m.529,12.48L74.1,42.793c-8.247,3.7-10.489,10.572-13.152,17.264-2.658-6.692-4.9-13.563-13.148-17.264l4.039-1.868a1.618,1.618,0,0,0,1.277-1.556c-.37-6.268,1.744-9.039,4.6-10.78a6.077,6.077,0,0,1,6.482,0c2.851,1.74,4.965,4.512,4.6,10.78a1.618,1.618,0,0,0,1.277,1.556ZM60.953,0A44.473,44.473,0,0,1,74.364,2.238,34.677,34.677,0,0,1,85.109,8.2c2.626.073,6.463-2.263,8.244-4.448C90.287,11.8,76.3,21.3,66.611,24.941H66.6a10.805,10.805,0,0,0-11.3,0h-.01C45.609,21.3,31.619,11.8,28.553,3.756,30.334,5.941,34.171,8.276,36.8,8.2A34.677,34.677,0,0,1,47.542,2.238,44.476,44.476,0,0,1,60.953,0M52.369,28.446a66.955,66.955,0,0,1-10.82-5.468,3.742,3.742,0,0,0-.487,3.512,4.073,4.073,0,0,0,1.6,1.733A8.231,8.231,0,0,0,45.58,29.3a11.7,11.7,0,0,0,6.789-.851" transform="translate(-20.953)" fill="#F2EFE9" fill-rule="evenodd"/>
            <path id="Pfad_28" data-name="Pfad 28" d="M62.593,61.529a53.31,53.31,0,0,0,5.291-6.612l.735,1.434a34.185,34.185,0,0,1,3.6,15.3l0,8.728.044,4.525A73.969,73.969,0,0,0,80,117.53l-10.993-9.185-7.778,13.08-8.171-7.971L40,135.412,26.942,113.454l-8.171,7.971-7.778-13.079L0,117.531A73.974,73.974,0,0,0,7.745,84.9l.044-4.525-.005-8.728a34.175,34.175,0,0,1,3.6-15.3l.735-1.434a53.307,53.307,0,0,0,5.291,6.612L16.77,62.9a11.341,11.341,0,0,0-.684,8.487,10.167,10.167,0,0,0,3.223,4.59,11.99,11.99,0,0,0,4.868,2.356,13.4,13.4,0,0,0,3.479.34,30.225,30.225,0,0,0-.4,4.927L16.889,89.81l8,4.648a13.293,13.293,0,0,1,1.82,1.273c6.6,6.138,10.563,24.3,13.289,33.165,2.726-8.869,6.692-27.027,13.29-33.165a13.273,13.273,0,0,1,1.82-1.273l8-4.648L52.742,83.6a30.226,30.226,0,0,0-.4-4.927,13.406,13.406,0,0,0,3.479-.34,11.988,11.988,0,0,0,4.868-2.356,10.166,10.166,0,0,0,3.223-4.59,11.341,11.341,0,0,0-.684-8.487l-.638-1.373Z" transform="translate(0 -40.299)" fill="#F2EFE9" fill-rule="evenodd"/>
          </svg>
        </a></li>
        <li><a class="btn-primary btn-social" href="https://www.pump.fun/zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775" rel="noopener" target="_blank" title="Pump.fun">
          <svg xmlns="http://www.w3.org/2000/svg" width="82.356" height="86.311" viewBox="0 0 82.356 86.311">
            <g id="layer1" transform="translate(-61.215 -51.044)">
              <g id="g1052" transform="translate(44.143 -156.872)">
                <g id="g7651">
                  <rect id="rect6703" width="13.108" height="25.582" transform="" fill="#fff"/>
                  <path id="path1062" d="M56.915,247.538,43.259,234.33l.858-.968c5.32-6,16.9-18.016,18.263-18.951a21.826,21.826,0,0,1,12.843-4.1c8.091-.016,13.307,3.8,15.722,11.494,2.152,6.859,1.348,13.838-2.208,19.139a21.16,21.16,0,0,0-1.659,2.717,12.819,12.819,0,0,1-1.884,2.084c-1.036,1.012-4.654,4.8-8.038,8.425s-6.251,6.582-6.369,6.58-6.361-5.948-13.871-13.213Z" fill="#fff"/>
                  <path id="path1060" d="M73.508,263.848l-3.115-3.158,2.591-2.715c1.009-1.057,4.484-4.744,7.746-8.17s5.93-6.3,5.93-6.391a26.793,26.793,0,0,1,1.578-2.514c3.381-5.042,4.146-11.678,2.1-18.2-1.308-4.169-3.877-7.614-6.852-9.192-.679-.36-1.1-.662-.931-.67.845-.043,4.88,2.523,6.829,4.344a22.4,22.4,0,0,1,6.294,20.7A19.354,19.354,0,0,1,90.6,247.891c-5.865,6.437-15.766,16.856-15.992,16.856a3.572,3.572,0,0,1-1.1-.9Z" fill="#e5e5e5"/>
                  <path id="path1058" d="M35.075,285.3c-5.812-1.306-11.946-5.843-14.262-10.549-1.1-2.232-1.194-2.719-1.182-6.025a23.03,23.03,0,0,1,2.476-10.852c.925-1.885,2.547-3.87,6.993-8.562,3.184-3.359,7.144-7.552,8.8-9.319l3.012-3.212L54.8,250.148c13.811,13.3,13.881,13.375,13.233,14.2-2.341,2.968-15.892,16.887-17.621,18.1A20.326,20.326,0,0,1,35.075,285.3ZM33.2,280.644c.322-.6.179-.924-.827-1.872-2.154-2.03-3.485-.663-1.392,1.43C32.339,281.564,32.669,281.63,33.2,280.644Zm-3.988-10.038a22.387,22.387,0,0,0-.5-4.69c-.64-.7-1.428.15-1.676,1.8-.522,3.482.585,7.935,1.853,7.449.429-.165.49-1.017.326-4.563Zm2.015-8.347c1.011-.949,1.126-2.1.246-2.436-.414-.159-.967.153-1.671.94-1.712,1.916-.441,3.25,1.425,1.5Z" fill="#c6c6c6"/>
                  <path id="path1056" d="M36.407,289.991c-6.789-1.828-12.249-7.332-14.547-14.665-.97-3.1-.9-3.255.354-.755a16.516,16.516,0,0,0,3.443,4.378c7.007,6.6,17.281,7.741,24.456,2.708a125.941,125.941,0,0,0,9.652-9.556l8.079-8.6h0l4.5,4.13-1.275,1.434c-5.033,5.659-15.662,16.7-17.086,17.741a20.8,20.8,0,0,1-6.912,3.251,30.7,30.7,0,0,1-10.668-.065Z" fill="#d3d3d3"/>
                  <path id="path1054" d="M37.7,294.013c-4.929-.734-8.748-2.773-12.916-6.894-5.531-5.47-7.686-10.6-7.709-18.349a23.437,23.437,0,0,1,3.621-13.582c1.723-2.751,2.92-4.138,11.873-13.758.993-1.067,5.292-5.749,9.554-10.4,14.259-15.574,17.219-18.388,21.741-20.671a22.971,22.971,0,0,1,10.979-2.44c4.69,0,6.209.344,10.482,2.374,2.911,1.383,3.768,2.015,6.526,4.813,5.233,5.308,7.568,10.828,7.579,17.918.01,6.5-1.665,11.739-5.112,15.994-.943,1.164-5.139,5.847-9.324,10.407s-9.99,10.907-12.9,14.105c-13.547,14.889-17.018,17.9-22.6,19.6a31.706,31.706,0,0,1-11.793.883Zm9.509-4.068c5.319-1.415,7.486-3.209,19.176-15.872l5.525-5.985-1.142-1.2c-.628-.66-7.564-7.4-15.414-14.978L41.08,238.133l-2.485,2.655c-1.367,1.46-5.1,5.417-8.306,8.793-6.389,6.737-7.653,8.63-8.828,13.226-2.975,11.633,3.912,24.151,14.919,27.115a30.142,30.142,0,0,0,10.827.023Zm33.8-31.964C93.461,244.649,93.8,244.2,95.075,239.313a29.838,29.838,0,0,0-.026-11.994,21.2,21.2,0,0,0-5.828-9.88,19.2,19.2,0,0,0-14.594-5.995,19.772,19.772,0,0,0-12.793,4.269c-1.677,1.28-17.466,17.921-17.733,18.69-.067.193,2.235,2.6,5.115,5.356s8.333,8.03,12.117,11.728c11.828,11.559,13.219,12.866,13.582,12.751.194-.061,2.935-2.877,6.092-6.256Z" fill="#f1f1f1"/>
                </g>
              </g>
            </g>
          </svg>
        </a></li>
        <li><a class="btn-primary btn-social" href="https://www.coingecko.com/de/munze/greg16676935420" rel="noopener" target="_blank" title="Coingecko">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="96" height="96" viewBox="0 0 96 96">
            <defs>
              <clipPath id="clip-path">
                <rect id="Rechteck_68" data-name="Rechteck 68" width="96" height="96" fill="#F2EFE9"/>
              </clipPath>
            </defs>
            <g id="coingecko_logo" clip-path="url(#clip-path)">
              <path id="Pfad_29" data-name="Pfad 29" d="M48.121,0A48,48,0,1,0,95.993,47.788,47.836,47.836,0,0,0,48.121,0ZM42.086,45.647a8.58,8.58,0,1,1,8.519-8.58A8.551,8.551,0,0,1,42.086,45.647Zm6.8,9.276.043-.054.046-.054a15.183,15.183,0,0,0,7.981,2.218,37.264,37.264,0,0,0,8.389-.7A45.678,45.678,0,0,0,73.5,53.792a41,41,0,0,0,4.361-2.077l.027-.017c.874-.528,1.727-1.087,2.564-1.662.183-.131.359-.268.531-.408l.02.023.073.087a30.979,30.979,0,0,1-7.29,4.71,46.419,46.419,0,0,1-8.187,3,25.477,25.477,0,0,1-8.732,1.014c-2.929-.261-6.015-1.295-7.987-3.536Zm21.867-9.276a1.847,1.847,0,1,1,1.857,1.85A1.858,1.858,0,0,1,70.749,45.647Zm-14.6,46.038c-1.84-12.989,9.422-25.71,15.773-32.219,1.441-1.475,3.67-3.509,5.742-5.67,8.243-7.764,9.884-17.04-6.988-21.676-3.2-.933-6.513-2.255-9.871-3.589a7.013,7.013,0,0,0-.365-.883,9.49,9.49,0,0,0-2.079-2.312c-2.192-1.917-6.314-1.866-9.871-1.017a24.678,24.678,0,0,0-11.541-.365C20.634,28.483,18.011,36.5,17.376,46.155c-.864,10.437-1.368,18.214-5.291,27.1A44.187,44.187,0,1,1,92.4,47.808,44.3,44.3,0,0,1,56.148,91.691Z" fill="#F2EFE9"/>
              <path id="Pfad_30" data-name="Pfad 30" d="M48.078,37.144a5.993,5.993,0,1,1-5.992-6.034A6.012,6.012,0,0,1,48.078,37.144Z" fill="#F2EFE9"/>
            </g>
          </svg>
        </a></li>
        <li><a class="btn-primary btn-social" href="https://jup.ag/swap/SOL-zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775" rel="noopener" target="_blank" title="Jupiter">
          <svg xmlns="http://www.w3.org/2000/svg" width="252.229" height="250" viewBox="0 0 252.229 250">
            <g id="logo-grayscale" transform="translate(-2 -3)">
              <path id="Pfad_29" data-name="Pfad 29" d="M26.146,199.614a128.38,128.38,0,0,0,90.786,52.734c-9.257-13.931-22.714-26.748-39.514-36.506S42.827,200.754,26.146,199.614Z" fill="#F2EFE9"/>
              <path id="Pfad_30" data-name="Pfad 30" d="M99.993,176.988c-32.366-18.8-67.4-23.6-92.464-15.13a128.947,128.947,0,0,0,9.529,23.121c21.778-.5,45.556,5.411,67.682,18.262s39.048,30.587,49.4,49.759a129.7,129.7,0,0,0,24.82-3.178C153.9,223.858,132.35,195.8,99.993,176.988Z" fill="#F2EFE9"/>
              <path id="Pfad_31" data-name="Pfad 31" d="M254.229,100.663A128.293,128.293,0,0,0,94.549,7.894c27.7,3.39,58.441,13.787,88.591,31.3S237.573,78.267,254.229,100.663Z" fill="#F2EFE9"/>
              <path id="Pfad_32" data-name="Pfad 32" d="M213.93,162.049c-14.177-23.544-38.463-46.09-68.38-63.47S84.024,71.272,56.573,70.615C32.422,70.043,14.3,77.064,6.856,89.872c-.042.076-.1.148-.148.225-.669,2.4-1.246,4.809-1.771,7.224,10.389-4.1,22.426-6.385,35.811-6.639,29.765-.559,63.076,8.961,93.815,26.82s55.53,42.09,69.783,68.215c6.39,11.771,10.377,23.359,11.957,34.43,1.839-1.644,3.644-3.343,5.394-5.11.046-.08.076-.165.123-.25C229.26,201.966,226.383,182.747,213.93,162.049Z" fill="#F2EFE9"/>
              <path id="Pfad_33" data-name="Pfad 33" d="M122.788,137.754C76.974,111.137,26.346,106.968,2,125.543a127.82,127.82,0,0,0,1.33,17.372,100.851,100.851,0,0,1,22.007-4.076c27.206-2.047,57.2,5.533,84.418,21.354s48.675,38.133,60.377,62.763a100.012,100.012,0,0,1,7.356,21.134,128.877,128.877,0,0,0,15.757-7.444C197.321,206.292,168.616,164.375,122.788,137.754Z" fill="#F2EFE9"/>
              <path id="Pfad_34" data-name="Pfad 34" d="M237.5,122.641c-14.338-23.519-38.837-46.128-68.966-63.622S106.67,31.44,79.13,30.631c-20.994-.606-37.256,4.483-45.688,14.1,35.01-5.932,81.189,4.038,125.949,30.04S235.7,135.954,247.876,169.3C252.05,157.224,248.419,140.577,237.5,122.641Z" fill="#F2EFE9"/>
            </g>
          </svg>
        </a></li>
        <li><a class="btn-primary btn-social" href="https://www.jeetscreener.com/token/zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775" rel="noopener" target="_blank" title="Jeetscreener">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" width="285.75mm" height="232.83078mm" viewBox="0 0 285.75 232.83078" version="1.1" id="svg1" xml:space="preserve"><defs id="defs1"/>
            <g id="layer1" transform="translate(37.877303,-30.718044)">
              <path id="path1" style="fill:#F2EFE9;stroke-width:2.99758" d="M 50.251685 30.718044 L 15.752498 40.40014 L -33.581958 94.99009 C -34.071167 95.379826 -34.496689 95.85108 -34.852165 96.395689 L -37.877303 99.743288 L 105.02612 263.54879 L 247.8727 100.20786 L 196.03865 40.388255 L 159.77368 30.718044 L 50.251685 30.718044 z M 51.900163 42.708527 L 158.20323 42.708527 L 179.28309 48.329372 L 150.98507 69.686725 L 59.148299 69.686725 L 32.008354 48.293199 L 51.900163 42.708527 z M 191.85131 53.868052 L 230.18024 98.098944 L 179.97452 121.37659 L 160.41757 77.589602 L 191.85131 53.868052 z M 19.729517 53.885105 L 49.700297 77.505369 L 30.111829 121.57761 L -19.915609 97.754779 L 19.729517 53.885105 z M 60.967826 81.676691 L 149.10922 81.676691 L 167.74167 123.39662 L 42.325037 123.62555 L 60.967826 81.676691 z M -6.5629353 117.39647 L 28.862293 134.26521 L 72.279797 207.77339 L -6.5629353 117.39647 z M 216.81258 117.5112 L 137.42052 208.2948 L 181.19718 134.02388 L 216.81258 117.5112 z M 166.4725 135.38814 L 105.02922 239.64018 L 43.585942 135.61448 L 166.4725 135.38814 z "/>
            </g>
          </svg>
        </a></li>
        <li><a class="btn-primary btn-social" href="https://holderscan.com/token/zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775" rel="noopener" target="_blank" title="Holderscan">
          <svg width="100%" height="100%" viewBox="0 0 180 172" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
            <g transform="matrix(1,0,0,1,-1150.45,-1668.15)">
                <g transform="matrix(3.77953,0,0,3.77953,778.643,1571.1)">
                    <path id="path1" d="M131.896,70.705C131.687,68.896 130.884,67.472 128.856,65.317C127.18,63.535 126.705,62.993 126.336,62.444C125.863,61.739 125.612,61.086 125.561,60.426L125.521,59.91L125.87,60.147C127.626,61.342 130.347,61.378 132.672,60.238C133.804,59.683 134.172,59.247 134.092,58.557L134.048,58.18L134.554,57.642C135.106,57.056 135.415,56.541 135.567,55.955C135.649,55.637 135.732,55.508 136.09,55.137C136.324,54.895 136.56,54.588 136.616,54.455C136.8,54.015 136.717,53.854 135.872,53.019C135.166,52.321 135.086,52.216 134.78,51.588C134.539,51.093 134.361,50.581 134.122,49.685C133.674,48.009 133.4,47.223 132.989,46.426C132.485,45.448 131.891,44.659 131.028,43.821C128.581,41.445 124.854,40.101 120.714,40.101C119.722,40.101 118.613,40.173 118.199,40.265C118.107,40.285 118.054,40.266 118.054,40.213C118.054,40.081 116.832,38.056 115.961,36.745C114.52,34.575 113.208,32.948 112.52,32.474L112.228,32.273L112.106,32.427C110.11,34.967 109.16,39.981 109.695,45.167C110.076,48.869 111.246,53.038 112.916,56.655C113.112,57.078 113.26,57.437 113.245,57.452C113.198,57.499 112.33,56.759 111.949,56.347C109.964,54.203 108.195,50.937 107.273,47.716C107.156,47.308 107.039,46.949 107.013,46.918C106.893,46.779 106.006,48.296 105.564,49.394C104.941,50.946 104.729,52.097 104.731,53.912C104.732,55.006 104.758,55.368 104.877,56.003C105.199,57.712 105.842,59.221 106.943,60.853C108.025,62.457 109.166,63.814 110.566,65.159L111.371,65.932L110.792,65.641C109.416,64.948 108.174,63.982 106.466,62.274C105.217,61.026 104.253,59.92 103.436,58.798C103.187,58.457 102.958,58.176 102.926,58.175C102.838,58.17 102.927,60.29 103.051,61.141C103.193,62.117 103.534,63.442 103.847,64.241C103.986,64.595 104.093,64.884 104.084,64.884C104.076,64.884 103.855,64.617 103.594,64.29C99.402,59.047 97.626,52.358 98.665,45.721C99.301,41.663 100.988,37.863 103.625,34.55C104.391,33.588 106.212,31.751 107.118,31.027C108.972,29.545 110.791,28.445 112.817,27.582C118.243,25.271 124.354,25.056 129.896,26.982C134.791,28.683 138.977,31.916 141.87,36.23C143.944,39.323 145.208,42.71 145.722,46.555C145.869,47.653 145.887,50.967 145.752,52.073C144.881,59.212 141.157,65.282 135.206,69.263C134.419,69.789 133.09,70.547 132.402,70.861L131.939,71.073L131.896,70.705ZM129.155,40.665C129.67,39.584 129.952,38.436 130.034,37.08C130.079,36.343 130.016,34.948 129.932,34.812C129.838,34.66 127.342,36.027 126.315,36.793C125.639,37.297 124.831,38.093 124.299,38.778L123.847,39.358L124.162,39.442C125.673,39.847 127.275,40.466 128.192,41.002C128.491,41.176 128.759,41.32 128.788,41.323C128.817,41.325 128.982,41.029 129.155,40.665ZM129.026,50.001C127.715,49.617 126.777,48.94 126.379,48.089C126.188,47.681 125.953,46.766 126.022,46.697C126.041,46.678 126.282,46.723 126.557,46.797C128.934,47.436 129.949,48.39 129.77,49.82C129.745,50.023 129.695,50.167 129.651,50.165C129.609,50.163 129.328,50.09 129.026,50.001L129.026,50.001Z" style="fill:rgb(242,239,233);fill-rule:nonzero;"/>
                </g>
            </g>
        </svg>
      </a></li>
      </ul>
  </div>
</section>
<footer>
  <div class="content">
    <h2>Remark</h2>
    <p>$GREG coin has no association with @greg16676935420. This token is simply paying homage to a meme we all love and recognize. This coin is a meme coin with no intrinsic value or expectation of financial return. There is no formal team or roadmap. The coin is completely useless and for entertainment purposes only.</p>
  </div>
</footer>`,
      },
      "/about": {
          template: ``,
          title: "ABOUT",
          html: `<section class="chapter about">
  <div class="content">
    <picture>
      <h1 class="chapter-name">About</h1>
      <h1 class="chapter-number">01</h1>
      <img src="./img/bladeRunner.jpg" alt="">
    </picture>
    <div>
      <h2 class="h3">In a Nutshell</h2>
      <p>Introducing Gregcoin - the ultimate fan tribute to @greg16676935420, where meme culture meets cryptocurrency! Imagine a coin not just for investment, but for community, laughs, and the sheer joy of being part of something hilariously unique. Gregcoin embodies the spirit of one of X's most beloved figures, offering you a stake in a digital currency that's as unpredictable as Greg's X posts.</p>
      <p>On 14/04/2021, greg16676935420 introduced the world to the idea of gregcoin, a joke memecoin in his image. A few years later (03/04/2024) a greg16676935420 coin was created and rugged on pump.fun by someone. Shortly after this same gregcoin spontaneously bonded and arrived on the open market. Over the following months, a tight knit community formed around gregcoin with believers coming from far and wide.</p>
      <p>We believe gregcoin is destined for gregillions, $16,676,935,420 to be precise.</p> 
      <p>Are you ready to take the greg pill?</p>
    </div>
  </div>
</section>
<footer>
    ${this.footer}
  </footer>`,
      },
      "/whitepaper": {
          template: ``,
          title: "WHITEPAPER",
          html: `<section class="chapter whitepaper">
  <div class="content">
    <div class="quote-block">
      <q class="h2">The GregCoin whitepaper is one of the most promising I’ve ever seen</q>
      <hr class="blockline"> 
      <span>Satoshi Narkamustard</span>
      <span class="caption">Bitcoin Creator</span>
    </div>
    <div>
      <hr class="blockline">
      <picture>
        <img src="./img/money_bw.jpg" alt="">
      </picture>
      <hr class="blockline">
    </div>
  </div>
</section>
<footer>
    ${this.footer}
  </footer>`,
      },
      "/connect": {
          template: ``,
          title: "LET'S GREG",
          html: `<section class="chapter connect">
	<div class="content">
		<picture>
			<h1 class="chapter-name">Let's greg</h1>
			<h1 class="chapter-number">02</h1>
			<img src="./img/money_bw.jpg" alt="">
		</picture>
		<div>
			<h2 class="h3">Need some? Get some!</h2>
			<p>Join the Gregcoin movement, where your investment is in the fun, the community, and perhaps, the next big meme. Remember, it's not just about the moonshot; it's about the journey and the laughs along the way. Welcome to Gregcoin, where every coin holds a piece of internet lore and a chance for something delightfully unexpected.</p>
			<div class="connect-block">
				<h5>DEX & CEX</h5>
				<hr class="blockline">
				<ul>
					<li><a class="btn-primary btn-social" href="https://jup.ag/swap/SOL-zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775" rel="noopener" target="_blank" title="Jupiter">
						<svg xmlns="http://www.w3.org/2000/svg" width="252.229" height="250" viewBox="0 0 252.229 250">
							<g id="logo-grayscale" transform="translate(-2 -3)">
								<path id="Pfad_29" data-name="Pfad 29" d="M26.146,199.614a128.38,128.38,0,0,0,90.786,52.734c-9.257-13.931-22.714-26.748-39.514-36.506S42.827,200.754,26.146,199.614Z" fill="#F2EFE9"/>
								<path id="Pfad_30" data-name="Pfad 30" d="M99.993,176.988c-32.366-18.8-67.4-23.6-92.464-15.13a128.947,128.947,0,0,0,9.529,23.121c21.778-.5,45.556,5.411,67.682,18.262s39.048,30.587,49.4,49.759a129.7,129.7,0,0,0,24.82-3.178C153.9,223.858,132.35,195.8,99.993,176.988Z" fill="#F2EFE9"/>
								<path id="Pfad_31" data-name="Pfad 31" d="M254.229,100.663A128.293,128.293,0,0,0,94.549,7.894c27.7,3.39,58.441,13.787,88.591,31.3S237.573,78.267,254.229,100.663Z" fill="#F2EFE9"/>
								<path id="Pfad_32" data-name="Pfad 32" d="M213.93,162.049c-14.177-23.544-38.463-46.09-68.38-63.47S84.024,71.272,56.573,70.615C32.422,70.043,14.3,77.064,6.856,89.872c-.042.076-.1.148-.148.225-.669,2.4-1.246,4.809-1.771,7.224,10.389-4.1,22.426-6.385,35.811-6.639,29.765-.559,63.076,8.961,93.815,26.82s55.53,42.09,69.783,68.215c6.39,11.771,10.377,23.359,11.957,34.43,1.839-1.644,3.644-3.343,5.394-5.11.046-.08.076-.165.123-.25C229.26,201.966,226.383,182.747,213.93,162.049Z" fill="#F2EFE9"/>
								<path id="Pfad_33" data-name="Pfad 33" d="M122.788,137.754C76.974,111.137,26.346,106.968,2,125.543a127.82,127.82,0,0,0,1.33,17.372,100.851,100.851,0,0,1,22.007-4.076c27.206-2.047,57.2,5.533,84.418,21.354s48.675,38.133,60.377,62.763a100.012,100.012,0,0,1,7.356,21.134,128.877,128.877,0,0,0,15.757-7.444C197.321,206.292,168.616,164.375,122.788,137.754Z" fill="#F2EFE9"/>
								<path id="Pfad_34" data-name="Pfad 34" d="M237.5,122.641c-14.338-23.519-38.837-46.128-68.966-63.622S106.67,31.44,79.13,30.631c-20.994-.606-37.256,4.483-45.688,14.1,35.01-5.932,81.189,4.038,125.949,30.04S235.7,135.954,247.876,169.3C252.05,157.224,248.419,140.577,237.5,122.641Z" fill="#F2EFE9"/>
							</g>
						</svg>
					</a></li>
				</ul>
			</div>
			<div class="connect-block">
				<h5>Chart & Details</h5>
				<hr class="blockline">
				<ul>
					<li><a class="btn-primary btn-social" href="https://www.dextools.io/app/en/solana/pair-explorer/B2FmE2iKFmHkWAroggcvdm5wQ8N15ndQDd9MCAdyZ34e?t=1712798706165" rel="noopener" target="_blank" title="Dextools">
						<svg xmlns="http://www.w3.org/2000/svg" width="754" height="867" viewBox="0 0 754 867">
							<path id="path2" d="M280.395,49.025c-51.649,26.9-93.9,49.672-93.9,50.6.023,2.39,123.959,65.156,128.358,65,2-.067,16.517-6.749,32.256-14.847l28.621-14.721,31.258,16.067,31.256,16.07,51.188-23c77.13-34.659,85.141-38.457,83.885-39.733-1.666-1.693-29.331-16.555-104.388-56.07-36.274-19.1-71.481-37.823-78.24-41.612S377.483-.058,376.356,0s-44.311,22.12-95.961,49.024ZM53.863,166.331.1,194.1V315.989C.1,383.027.8,437.874,1.669,437.874s27.316-11.467,58.783-25.482l57.213-25.482V258.434l27.958,15.232q32.323,17.6,64.676,35.115l36.707,19.871,16.336-7.387q15.369-6.96,30.674-14.056c7.885-3.672,27.241-12.39,43.012-19.377s30.37-14.019,32.44-15.621c2.75-2.128-30.782-20.658-124.025-68.54-70.285-36.093-130.046-65.509-132.8-65.368s-29.206,12.752-58.778,28.028Zm529.148,7.8c-36.618,16.531-66.6,30.717-66.638,31.526s19.926,12.675,44.354,26.367,44.412,25.632,44.412,26.531-21.615,11.37-48.03,23.278-93.194,42.061-148.393,67.014l-184.954,83.6c-46.525,21.032-88.462,39.989-93.193,42.132C35.539,517.6,9.419,529.536,5.832,531.585c-3.607,2.063-4.424,14.048-5.066,74.2L0,677.53l48.08,24.5,48.079,24.5,66.669-30.088C199.5,679.89,229.5,665.484,229.5,664.423s-6.776-5.473-15.054-9.815-25.378-13.954-37.995-21.364-25.2-14.21-27.958-15.112-4.98-2.472-4.935-3.5,29.4-14.968,65.236-30.991c69.6-31.117,122.858-55.1,237.2-106.809q76.757-34.626,153.468-69.271c44.891-20.327,97.151-44.022,116.077-52.694l34.41-15.767.765-72.561.769-72.558-48.765-25.03c-26.822-13.765-49.748-24.994-50.95-24.953s-32.141,13.6-68.756,30.13ZM736.883,435.9c-7.186,3.51-21.38,10.082-31.542,14.6s-29.446,13.222-42.852,19.339l-24.374,11.117-.556,63.7c-.307,35.035-1.6,63.545-2.867,63.36-2.885-.429-48.567-23.857-94.487-48.463C507.062,541.8,504.98,541.1,497.192,544.954c-4.5,2.231-31.413,14.3-59.8,26.825s-52.541,23.587-53.677,24.589,56,31.967,126.97,68.819l129.029,67,55.119-28.513c30.312-15.68,56.088-29.983,57.275-31.782,2.672-4.045,2.443-242.93-.232-242.607-1.058.127-7.806,3.1-14.992,6.614ZM431.656,716.293q-14.338,6.161-28.674,12.346c-28.857,12.487-23.2,12.9-57.532-4.189-22.865-11.382-32.721-14.894-37-13.189-3.209,1.278-30.826,13.7-61.376,27.61s-56.6,25.285-57.9,25.285c-12.817,0,8.491,12.731,90.714,54.207L376.319,867l40.572-20.03c22.315-11.017,67.323-33.078,100.021-49.024s59.042-29.413,58.549-29.921-27.893-14.574-60.883-31.262L454.6,706.425Z" transform="translate(0 0)" fill="#F2EFE9" fill-rule="evenodd"/>
						</svg>
					</a></li>
					<li><a class="btn-primary btn-social" href="https://dexscreener.com/solana/B2FmE2iKFmHkWAroggcvdm5wQ8N15ndQDd9MCAdyZ34e" rel="noopener" target="_blank" title="Dexscreener">
						<svg id="dexscreener_logo" xmlns="http://www.w3.org/2000/svg" width="80" height="95.113" viewBox="0 0 80 95.113">
							<path id="Pfad_27" data-name="Pfad 27" d="M69.537,28.446a66.957,66.957,0,0,0,10.821-5.468,3.741,3.741,0,0,1,.487,3.512,4.069,4.069,0,0,1-1.6,1.733A8.227,8.227,0,0,1,76.326,29.3a11.7,11.7,0,0,1-6.789-.851m.529,12.48L74.1,42.793c-8.247,3.7-10.489,10.572-13.152,17.264-2.658-6.692-4.9-13.563-13.148-17.264l4.039-1.868a1.618,1.618,0,0,0,1.277-1.556c-.37-6.268,1.744-9.039,4.6-10.78a6.077,6.077,0,0,1,6.482,0c2.851,1.74,4.965,4.512,4.6,10.78a1.618,1.618,0,0,0,1.277,1.556ZM60.953,0A44.473,44.473,0,0,1,74.364,2.238,34.677,34.677,0,0,1,85.109,8.2c2.626.073,6.463-2.263,8.244-4.448C90.287,11.8,76.3,21.3,66.611,24.941H66.6a10.805,10.805,0,0,0-11.3,0h-.01C45.609,21.3,31.619,11.8,28.553,3.756,30.334,5.941,34.171,8.276,36.8,8.2A34.677,34.677,0,0,1,47.542,2.238,44.476,44.476,0,0,1,60.953,0M52.369,28.446a66.955,66.955,0,0,1-10.82-5.468,3.742,3.742,0,0,0-.487,3.512,4.073,4.073,0,0,0,1.6,1.733A8.231,8.231,0,0,0,45.58,29.3a11.7,11.7,0,0,0,6.789-.851" transform="translate(-20.953)" fill="#F2EFE9" fill-rule="evenodd"/>
							<path id="Pfad_28" data-name="Pfad 28" d="M62.593,61.529a53.31,53.31,0,0,0,5.291-6.612l.735,1.434a34.185,34.185,0,0,1,3.6,15.3l0,8.728.044,4.525A73.969,73.969,0,0,0,80,117.53l-10.993-9.185-7.778,13.08-8.171-7.971L40,135.412,26.942,113.454l-8.171,7.971-7.778-13.079L0,117.531A73.974,73.974,0,0,0,7.745,84.9l.044-4.525-.005-8.728a34.175,34.175,0,0,1,3.6-15.3l.735-1.434a53.307,53.307,0,0,0,5.291,6.612L16.77,62.9a11.341,11.341,0,0,0-.684,8.487,10.167,10.167,0,0,0,3.223,4.59,11.99,11.99,0,0,0,4.868,2.356,13.4,13.4,0,0,0,3.479.34,30.225,30.225,0,0,0-.4,4.927L16.889,89.81l8,4.648a13.293,13.293,0,0,1,1.82,1.273c6.6,6.138,10.563,24.3,13.289,33.165,2.726-8.869,6.692-27.027,13.29-33.165a13.273,13.273,0,0,1,1.82-1.273l8-4.648L52.742,83.6a30.226,30.226,0,0,0-.4-4.927,13.406,13.406,0,0,0,3.479-.34,11.988,11.988,0,0,0,4.868-2.356,10.166,10.166,0,0,0,3.223-4.59,11.341,11.341,0,0,0-.684-8.487l-.638-1.373Z" transform="translate(0 -40.299)" fill="#F2EFE9" fill-rule="evenodd"/>
						</svg>
					</a></li>
					<li><a class="btn-primary btn-social" href="https://www.coingecko.com/de/munze/greg16676935420" rel="noopener" target="_blank" title="Coingecko">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="96" height="96" viewBox="0 0 96 96">
							<defs>
								<clipPath id="clip-path">
									<rect id="Rechteck_68" data-name="Rechteck 68" width="96" height="96" fill="#F2EFE9"/>
								</clipPath>
							</defs>
							<g id="coingecko_logo" clip-path="url(#clip-path)">
								<path id="Pfad_29" data-name="Pfad 29" d="M48.121,0A48,48,0,1,0,95.993,47.788,47.836,47.836,0,0,0,48.121,0ZM42.086,45.647a8.58,8.58,0,1,1,8.519-8.58A8.551,8.551,0,0,1,42.086,45.647Zm6.8,9.276.043-.054.046-.054a15.183,15.183,0,0,0,7.981,2.218,37.264,37.264,0,0,0,8.389-.7A45.678,45.678,0,0,0,73.5,53.792a41,41,0,0,0,4.361-2.077l.027-.017c.874-.528,1.727-1.087,2.564-1.662.183-.131.359-.268.531-.408l.02.023.073.087a30.979,30.979,0,0,1-7.29,4.71,46.419,46.419,0,0,1-8.187,3,25.477,25.477,0,0,1-8.732,1.014c-2.929-.261-6.015-1.295-7.987-3.536Zm21.867-9.276a1.847,1.847,0,1,1,1.857,1.85A1.858,1.858,0,0,1,70.749,45.647Zm-14.6,46.038c-1.84-12.989,9.422-25.71,15.773-32.219,1.441-1.475,3.67-3.509,5.742-5.67,8.243-7.764,9.884-17.04-6.988-21.676-3.2-.933-6.513-2.255-9.871-3.589a7.013,7.013,0,0,0-.365-.883,9.49,9.49,0,0,0-2.079-2.312c-2.192-1.917-6.314-1.866-9.871-1.017a24.678,24.678,0,0,0-11.541-.365C20.634,28.483,18.011,36.5,17.376,46.155c-.864,10.437-1.368,18.214-5.291,27.1A44.187,44.187,0,1,1,92.4,47.808,44.3,44.3,0,0,1,56.148,91.691Z" fill="#F2EFE9"/>
								<path id="Pfad_30" data-name="Pfad 30" d="M48.078,37.144a5.993,5.993,0,1,1-5.992-6.034A6.012,6.012,0,0,1,48.078,37.144Z" fill="#F2EFE9"/>
							</g>
						</svg>
					</a></li>
          <li><a class="btn-primary btn-social" href="https://www.jeetscreener.com/token/zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775" rel="noopener" target="_blank" title="Jeetscreener">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" width="285.75mm" height="232.83078mm" viewBox="0 0 285.75 232.83078" version="1.1" id="svg1" xml:space="preserve"><defs id="defs1"/>
              <g id="layer1" transform="translate(37.877303,-30.718044)">
                <path id="path1" style="fill:#F2EFE9;stroke-width:2.99758" d="M 50.251685 30.718044 L 15.752498 40.40014 L -33.581958 94.99009 C -34.071167 95.379826 -34.496689 95.85108 -34.852165 96.395689 L -37.877303 99.743288 L 105.02612 263.54879 L 247.8727 100.20786 L 196.03865 40.388255 L 159.77368 30.718044 L 50.251685 30.718044 z M 51.900163 42.708527 L 158.20323 42.708527 L 179.28309 48.329372 L 150.98507 69.686725 L 59.148299 69.686725 L 32.008354 48.293199 L 51.900163 42.708527 z M 191.85131 53.868052 L 230.18024 98.098944 L 179.97452 121.37659 L 160.41757 77.589602 L 191.85131 53.868052 z M 19.729517 53.885105 L 49.700297 77.505369 L 30.111829 121.57761 L -19.915609 97.754779 L 19.729517 53.885105 z M 60.967826 81.676691 L 149.10922 81.676691 L 167.74167 123.39662 L 42.325037 123.62555 L 60.967826 81.676691 z M -6.5629353 117.39647 L 28.862293 134.26521 L 72.279797 207.77339 L -6.5629353 117.39647 z M 216.81258 117.5112 L 137.42052 208.2948 L 181.19718 134.02388 L 216.81258 117.5112 z M 166.4725 135.38814 L 105.02922 239.64018 L 43.585942 135.61448 L 166.4725 135.38814 z "/>
              </g>
            </svg>
          </a></li>
          <li><a class="btn-primary btn-social" href="https://holderscan.com/token/zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775" rel="noopener" target="_blank" title="Holderscan">
          <svg width="100%" height="100%" viewBox="0 0 180 172" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
            <g transform="matrix(1,0,0,1,-1150.45,-1668.15)">
                <g transform="matrix(3.77953,0,0,3.77953,778.643,1571.1)">
                    <path id="path1" d="M131.896,70.705C131.687,68.896 130.884,67.472 128.856,65.317C127.18,63.535 126.705,62.993 126.336,62.444C125.863,61.739 125.612,61.086 125.561,60.426L125.521,59.91L125.87,60.147C127.626,61.342 130.347,61.378 132.672,60.238C133.804,59.683 134.172,59.247 134.092,58.557L134.048,58.18L134.554,57.642C135.106,57.056 135.415,56.541 135.567,55.955C135.649,55.637 135.732,55.508 136.09,55.137C136.324,54.895 136.56,54.588 136.616,54.455C136.8,54.015 136.717,53.854 135.872,53.019C135.166,52.321 135.086,52.216 134.78,51.588C134.539,51.093 134.361,50.581 134.122,49.685C133.674,48.009 133.4,47.223 132.989,46.426C132.485,45.448 131.891,44.659 131.028,43.821C128.581,41.445 124.854,40.101 120.714,40.101C119.722,40.101 118.613,40.173 118.199,40.265C118.107,40.285 118.054,40.266 118.054,40.213C118.054,40.081 116.832,38.056 115.961,36.745C114.52,34.575 113.208,32.948 112.52,32.474L112.228,32.273L112.106,32.427C110.11,34.967 109.16,39.981 109.695,45.167C110.076,48.869 111.246,53.038 112.916,56.655C113.112,57.078 113.26,57.437 113.245,57.452C113.198,57.499 112.33,56.759 111.949,56.347C109.964,54.203 108.195,50.937 107.273,47.716C107.156,47.308 107.039,46.949 107.013,46.918C106.893,46.779 106.006,48.296 105.564,49.394C104.941,50.946 104.729,52.097 104.731,53.912C104.732,55.006 104.758,55.368 104.877,56.003C105.199,57.712 105.842,59.221 106.943,60.853C108.025,62.457 109.166,63.814 110.566,65.159L111.371,65.932L110.792,65.641C109.416,64.948 108.174,63.982 106.466,62.274C105.217,61.026 104.253,59.92 103.436,58.798C103.187,58.457 102.958,58.176 102.926,58.175C102.838,58.17 102.927,60.29 103.051,61.141C103.193,62.117 103.534,63.442 103.847,64.241C103.986,64.595 104.093,64.884 104.084,64.884C104.076,64.884 103.855,64.617 103.594,64.29C99.402,59.047 97.626,52.358 98.665,45.721C99.301,41.663 100.988,37.863 103.625,34.55C104.391,33.588 106.212,31.751 107.118,31.027C108.972,29.545 110.791,28.445 112.817,27.582C118.243,25.271 124.354,25.056 129.896,26.982C134.791,28.683 138.977,31.916 141.87,36.23C143.944,39.323 145.208,42.71 145.722,46.555C145.869,47.653 145.887,50.967 145.752,52.073C144.881,59.212 141.157,65.282 135.206,69.263C134.419,69.789 133.09,70.547 132.402,70.861L131.939,71.073L131.896,70.705ZM129.155,40.665C129.67,39.584 129.952,38.436 130.034,37.08C130.079,36.343 130.016,34.948 129.932,34.812C129.838,34.66 127.342,36.027 126.315,36.793C125.639,37.297 124.831,38.093 124.299,38.778L123.847,39.358L124.162,39.442C125.673,39.847 127.275,40.466 128.192,41.002C128.491,41.176 128.759,41.32 128.788,41.323C128.817,41.325 128.982,41.029 129.155,40.665ZM129.026,50.001C127.715,49.617 126.777,48.94 126.379,48.089C126.188,47.681 125.953,46.766 126.022,46.697C126.041,46.678 126.282,46.723 126.557,46.797C128.934,47.436 129.949,48.39 129.77,49.82C129.745,50.023 129.695,50.167 129.651,50.165C129.609,50.163 129.328,50.09 129.026,50.001L129.026,50.001Z" style="fill:rgb(242,239,233);fill-rule:nonzero;"/>
                </g>
            </g>
        </svg>
      </a></li>
				</ul>
			</div>
      <div class="connect-block">
				<h5>SAY HELLO</h5>
				<hr class="blockline">
				<ul>
					<li><a class="btn-primary btn-social" href="https://twitter.com/realgregcoin" rel="noopener" target="_blank" title="X">
            <svg xmlns="http://www.w3.org/2000/svg" width="300.1" height="271" viewBox="0 0 300.1 271">
              <path id="path2" d="M236,0h46L181,115,299,271H206.4l-72.5-94.8L50.9,271H4.9l107-123L-1.1,0H93.8l65.5,86.6ZM219.9,244h25.5L80.4,26H53Z" transform="translate(1.1)" fill="#F2EFE9"/>
            </svg>
          </a></li>
					<li><a class="btn-primary btn-social" href="https://t.me/gregcoin69" rel="noopener" target="_blank" title="Telegram">
            <svg xmlns="http://www.w3.org/2000/svg" width="543" height="450" viewBox="0 0 543 450">
              <g id="Artboard" transform="translate(-189 -301)">
                <path id="Path-3" d="M226.328,494.722q218.64-95.258,291.589-125.6C656.772,311.367,685.625,301.335,704.431,301c4.136-.073,13.384.952,19.375,5.813,5.058,4.1,6.45,9.649,7.116,13.541a88.185,88.185,0,0,1,.836,19.683c-7.525,79.062-40.083,270.924-56.648,359.475-7.009,37.469-20.81,50.032-34.17,51.262-29.036,2.672-51.084-19.189-79.207-37.624-44.007-28.847-68.867-46.8-111.583-74.953-49.366-32.531-17.364-50.411,10.769-79.631,7.363-7.647,135.3-124.012,137.772-134.568.31-1.32.6-6.241-2.326-8.84s-7.239-1.71-10.352-1q-6.621,1.5-210.9,139.4-29.932,20.554-54.223,20.029c-17.853-.386-52.194-10.094-77.723-18.393-31.312-10.179-56.2-15.56-54.032-32.846q1.693-13.506,37.2-27.624Z" fill="#F2EFE9" fill-rule="evenodd"/>
              </g>
            </svg>
          </a></li>
				</ul>
			</div>
			<div class="connect-block">
				<h5>Contract Address</h5>
				<hr class="blockline">
				<a class="btn-primary btn ca-copy" href="#" role="button" data-owner="copy-contract-adr">
					<span>zZRR...5775</span>
					<svg xmlns="http://www.w3.org/2000/svg" width="19.018" height="25.025" viewBox="0 0 19.018 25.025">
						<g id="Gruppe_59" data-name="Gruppe 59" transform="translate(-174.482 -1288.463)">
							<path id="Pfad_30" data-name="Pfad 30" d="M0,0H14V20H0Z" transform="translate(175 1293)" fill="none"/>
							<path id="Pfad_31" data-name="Pfad 31" d="M-12837.5-3409h-5.517v19.988h13.52v-4.978h4.5v-19.048h-12.5v19.048h8" transform="translate(13018 4702)" fill="none" stroke="#F2EFE9" stroke-linecap="square" stroke-width="2"/>
						</g>
					</svg>
				</a>
			</div>
		</div>
	</div>
</section>
<footer>
    ${this.footer}
  </footer>`,
      },
      "/memes": {
          template: ``,
          title: "MEMES",
          html: `<section class="chapter memes">
  <div class="content">
    <picture>
      <h1 class="chapter-name">Memes</h1>
      <h1 class="chapter-number">05</h1>
      <img src="" alt="">
    </picture>
    <div>
      <h2 class="h3">Community memes</h2>
      <p>Memes created by the community to spread $GREG all over the known multiverse. Download and view our memes <a class="textlink" href="https://www.dropbox.com/scl/fo/601czr7c35ah1ip9khfwd/ABiBcA76bbDcUl2qYMPIso0?rlkey=rjach9w3wervmhzu6ixqyyhnt&st=8xpb255v&dl=0" rel="noopener" target="_blank" title="memeCloud">here</a> or just skip through a few selcted images below.</p>
      <div class="viewbox vb-memes">
        <div class="viewbox-controls">
          <li><a class="btn-primary btn-social" role="button" data-owner="lightbox-next">&#9654;</a></li>
            <li><a class="btn-primary btn-social" role="button" data-owner="lightbox-previous">&#9664;</a></li>
        </div>
      </div>
    </div>
  </div>
</section>
<footer>
${this.footer}
</footer>`,
      },
      "/charity": {
          template: ``,
          title: "CHARITY",
          html: `<section class="chapter charity">
	<div class="content">
		<picture>
			<h1 class="chapter-name">Charity</h1>
			<h1 class="chapter-number">03</h1>
			<img src="./img/money_bw.jpg" alt="">
		</picture>
		<div>
			<h2 class="h3">The Spirit of Greg</h2>
			<p>This gregcoin, inspired by the charitable spirit of greg, aims to support various charities as its price appreciates, reflecting a commitment to give back and make a positive impact with its growth.</p>
      <p>Gregcoin has established a public charity <a class="underline" href="https://solscan.io/account/APSEqYjPo8fv8MKJHSkJmSqQL1M4uEiWrHx6v2HDKNiV" rel="noopener" target="_blank" title="Charity Wallet">wallet</a> to which community members and supporters can directly contribute, furthering our collective efforts to support causes close to greg's heart.</p>
			<div class="connect-block">
				<h5>Wallet Balance</h5>
				<hr class="blockline">
				<span class="charity-balance">FETCHING DATA</span>
			</div>
			<div class="connect-block">
				<h5>Wallet Address</h5>
				<hr class="blockline">
				<a class="btn-primary btn ca-copy" href="#" role="button" data-owner="copy-charity-adr">
					<span>APSE...KNiV</span>
					<svg xmlns="http://www.w3.org/2000/svg" width="19.018" height="25.025" viewBox="0 0 19.018 25.025">
						<g id="Gruppe_59" data-name="Gruppe 59" transform="translate(-174.482 -1288.463)">
							<path id="Pfad_30" data-name="Pfad 30" d="M0,0H14V20H0Z" transform="translate(175 1293)" fill="none"/>
							<path id="Pfad_31" data-name="Pfad 31" d="M-12837.5-3409h-5.517v19.988h13.52v-4.978h4.5v-19.048h-12.5v19.048h8" transform="translate(13018 4702)" fill="none" stroke="#F2EFE9" stroke-linecap="square" stroke-width="2"/>
						</g>
					</svg>
				</a>
			</div>
		</div>
	</div>
</section>
<footer>
    ${this.footer}
</footer>`,
      },
    }
    this.contentImages = {
      about: {url: '/img/bladeRunner.jpg', img: ''},
      connect: {url: '/img/money_bw.jpg', img: ''},
      whitepaper: {url: '/img/whitepaper.jpg', img: ''},
      charity: {url: '/img/charity.jpg', img: ''},
      memes: {url: '/img/insane.jpg', img: ''}
    }
    this.navSVGIcons = [
      `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 40 25" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;">
						<g transform="matrix(1,0,0,1,-0.25,-8.88178e-16)">
								<g transform="matrix(1,0,0,1,-1726.14,-42.7259)">
										<g id="Linie_145" transform="matrix(1,0,0,1,1730.51,46.849)">
												<path d="M31.5,0L0,16" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:2px;"/>
										</g>
								</g>
								<g transform="matrix(1,0,0,1,-1726.14,-42.7259)">
										<g id="Linie_146" transform="matrix(1,0,0,1,1730.51,62.849)">
												<path d="M31.5,0L0,-16" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:2px;"/>
										</g>
								</g>
						</g>
				</svg>`,
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 40 25" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;">
								<g transform="matrix(1,0,0,1,-0.25,-8.88178e-16)">
										<g id="Gruppe_55" transform="matrix(1,0,0,1,-1726.14,-42.7259)">
												<g id="Linie_145" transform="matrix(1,0,0,1,1730.51,46.849)">
														<path d="M31.5,0L0,0" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:2px;"/>
												</g>
												<g id="Linie_146" transform="matrix(1,0,0,1,1730.51,62.849)">
														<path d="M31.5,0L0,0" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:2px;"/>
												</g>
										</g>
								</g>
						</svg>`
    ]
    this.loaderAscii = document.querySelectorAll('pre')
    this.$k = document.querySelector('#k').getAttribute('title')
    this.ini()
  }
  async ini() {
    this.showLoaderAscii(12)
    this.randomAccentColor()
    this.setCssColors()
    this.showLoaderAscii(25)
    await this.getPriceAndBalance()
    this.showLoaderAscii(45)
    await this.loadContentImages()
    this.locationHandler()
    this.navMenuTL()
    this.navBarTL()
    this.showLoaderAscii(84)
    this.addLenis()
    // await this.fetchPages()      
    this.scene = new Scene(this.colors)
    await this.checkSceneReadiness()
    this.showLoaderAscii(100)
    this.removeLoaderOverlay()
  }
  async checkSceneReadiness() {
    return new Promise((resolve, reject) => {
      const sceneCheck = setInterval(() => {
        // console.log('checking')
          if(this.scene.sceneIsReady) {
            clearInterval(sceneCheck);
            // console.log('resolved')
            resolve()
          }
        }, 500);
        sceneCheck
    })
  }
  async getPriceAndBalance() {
    this.priceAndBalance = {}
    var wallet_accounts_balances = {}
    const mintKeys = []
    const mintBalances = []

    //get charity wallet balances
    const wallet = new PublicKey('APSEqYjPo8fv8MKJHSkJmSqQL1M4uEiWrHx6v2HDKNiV')
    var walletBalance = null
    this.priceAndBalance = null
    const programID = new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')
    const solana = new Connection(`https://floral-necessary-crater.solana-mainnet.quiknode.pro/443faf87783d9f7a713d15540db47927f8554${this.$k}/`);

    const getWalletBalance = async () => {
      try {
        const wallet_sol_balance = await solana.getBalance(wallet)
        wallet_accounts_balances = {...wallet_accounts_balances, 'So11111111111111111111111111111111111111112': wallet_sol_balance / LAMPORTS_PER_SOL}
    
        //get all mint accounts
        var walletMintAccounts = await solana.getParsedTokenAccountsByOwner(wallet,
          {
            programId: programID
          }
        )
    
        walletMintAccounts.value.forEach(account => {
          const mint = account.account.data.parsed.info.mint
          const tokenAmount = account.account.data.parsed.info.tokenAmount.uiAmount
          wallet_accounts_balances = {...wallet_accounts_balances, [mint]: tokenAmount }      
        })
    
        Object.keys(wallet_accounts_balances).forEach( account => {
          mintKeys.push(account)
        })
    
        // console.log(wallet_accounts_balances)
      } catch(err) {
        // console.log(err)
        return
      }
    }

    const getPrices = async () => {

      try{
        //get mint/token prices
        var mints_prices = await fetch(`https://api.jup.ag/price/v2?ids=${mintKeys.join(',')},So11111111111111111111111111111111111111112, zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775`)
        mints_prices = await mints_prices.json()
        // console.log(mints_prices)
        mintKeys.forEach(key => {
          if(mints_prices.data[key] === null) {
            return
          } else {
            // console.log(key)
            const mintBalance = mints_prices.data[key].price * wallet_accounts_balances[key]
            mintBalances.push(mintBalance)
            // console.log(mintBalance)
          }
        })
        const initialValue = 0;

        if(mintBalances.length > 0) {
          walletBalance = mintBalances.reduce(
          (accumulator, currentValue) => accumulator + currentValue,
            initialValue,
          )
        }
    
        this.priceAndBalance = {...this.priceAndBalance, charityWalletBalance: walletBalance}
    
        this.priceAndBalance = {...this.priceAndBalance, greg_usdc: mints_prices.data['zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775'].price}
        
        const greg_sol = Number(this.priceAndBalance.greg_usdc) / Number(mints_prices.data['So11111111111111111111111111111111111111112'].price)
        this.priceAndBalance = {...this.priceAndBalance, greg_sol: greg_sol.toFixed(9)}
    
        // console.log('priceBalance', this.priceAndBalance)

      } catch(err) {
        // console.log(err)
        return
      }

    }
    await getWalletBalance()
    await getPrices()
    // console.log('all done')
  }
  async loadContentImages() {
    return new Promise((resolve, reject) => {
      const getImages = async () => {
        var count = 0
        const end = Object.keys(this.contentImages).length
        for(const img of Object.keys(this.contentImages)) {
          count++
          // console.log(this.contentImages)
          const response = await fetch( this.contentImages[img].url )
          const imageBlob = await response.blob()
          this.contentImages[img].img = URL.createObjectURL( imageBlob )
          // console.log(this.contentImages[img].img)
          if(count === end) {
            resolve()
          }
        }
      }
      getImages()
    })
  }
  randomAccentColor() {

    const colorIndex = 0
    // removed randomnes - blue is fixed accent color
    // var colorIndex = Math.floor(Math.random() * (5 - 1) + 1) - 1
    // colorIndex === 4 ? colorIndex = 0 : colorIndex = colorIndex
    this.colors.accentHard = `rgb(${this.accentVariations[colorIndex]})`
    this.colors.accentHardValues = `${this.accentVariations[colorIndex]}`
    document.querySelector('meta[name="theme-color"]').setAttribute('content',  this.accentVariationsHex[colorIndex]);
  }
  removeLoaderOverlay() {
    const loaderOverlay = document.querySelector('.loader-overlay')
    gsap.to(loaderOverlay, {duration: 0.64, y: '100%'})
    this.lenis.start()
  }
  setCssColors() {
    const style = document.documentElement.style
    Object.keys(this.colors).forEach(clr => {
      style.setProperty(`--clr-${clr}`, this.colors[clr])
    })
  }
  showLoaderAscii(percent) {
    const onePercent = this.loaderAscii.length / 100

    for(var i = 0; i < onePercent * percent; i++) {
      this.loaderAscii[i].style.color = 'var(--clr-light)'
    }

  }
  addLenis() {
    //lenis
    this.lenis = new Lenis()
    this.scrollValue = 0
    this.lenis.on('scroll', (e) => {
    this.scrollValue -= e.velocity
    this.scene.basicUniforms.uScrollVelocity.value = this.scrollValue
    this.scene.particles.position.y = -this.scrollValue / 900

    // console.log(e.velocity, this.navBarIsVisible)
    
    if(e.velocity > 0 && this.navBarIsVisible) {
      this.toggleNavBar()
    } else if(e.velocity < 0 && !this.navBarIsVisible) {
      this.toggleNavBar()
    }
    })

    const raf = (time) => {
      this.lenis.raf(time)
      requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)
    this.lenis.stop()
  }
  navMenuTL() {
    this.tl__menu = new gsap.timeline({paused:true})
    const menu = document.querySelector('.nav-menu')
    const navBar = document.querySelector('.nav-bar')
    this.tl__menu.to(menu, {duration: .24, y:'0%'})
    this.tl__menu.reverse()
  }
  navBarTL() {
    this.tl__navBar = new gsap.timeline({paused:true})
    const navBar = document.querySelector('nav')
    this.tl__navBar.to(navBar, {duration: .44, y:'-100%'}).reverse()
  }
  toggleNavMenu() {
    this.tl__menu.reversed(!this.tl__menu.reversed())
    if(this.navMenuIsOpen) {
      this.navMenuIsOpen = false
      document.querySelector('[data-owner=nav-menu]').innerHTML = this.navSVGIcons[1]
    } else {
      this.navMenuIsOpen = true
      document.querySelector('[data-owner=nav-menu]').innerHTML = this.navSVGIcons[0]
    }
  }
  toggleNavBar() {
    this.tl__navBar.reversed(!this.tl__navBar.reversed())
    this.navBarIsVisible === true ? this.navBarIsVisible = false : this.navBarIsVisible = true
  }
  addEventListeners() {
    const controlElements = document.querySelector('main').querySelectorAll('[data-owner]')
    if(controlElements.length > 0 ) {
      controlElements.forEach(controlElement => {
        controlElement.addEventListener('click', (e) => { this.clickEvent(e)})
      }) 
    }
    if(!this.stateListenerAdded) {
      window.addEventListener("popstate", e => {
        this.locationHandler()
      })
      window.addEventListener("hashchange", e => {
        // this.locationHandler()
      })
      const navBtn = document.querySelector('nav').querySelectorAll('[data-owner]')
      navBtn.forEach(btn => {
        btn.addEventListener('click', (e) => { this.clickEvent(e)})
      })
      document.addEventListener('click', (e) => {
        if(this.navMenuIsOpen && !e.target.closest('.nav-menu')) {
          this.toggleNavMenu()
        }
      })
      this.stateListenerAdded = true
    }
  }
  async fetchPages() {
    for( var page of this.pages ) {
      const response = await fetch(`./sites/${page}.html`)
      const pageContent = await response.text()
      if( page === 'home' ) { page = '/' } else { page = '/' + page }
      this.routes[ page ].html = pageContent
    }
  }
  async clickEvent(e) {
    const eventOwner = e.target.getAttribute('data-owner')
    e.preventDefault()
    var textContent
    // console.log(eventOwner)
    switch(eventOwner) {
      case 'home':
        if(this.navMenuIsOpen) {this.toggleNavMenu()}
        // this.isCurrentLocation = eventOwner
        this.route( e )
        break
      case 'whitepaper':
        if(this.navMenuIsOpen) {this.toggleNavMenu()}
        // this.isCurrentLocation = eventOwner
        this.route( e )
        break
      case 'about':
        if(this.navMenuIsOpen) {this.toggleNavMenu()}
        // this.isCurrentLocation = eventOwner
        this.route( e )
        break
      case 'memes':
        if(this.navMenuIsOpen) {this.toggleNavMenu()}
        // this.isCurrentLocation = eventOwner
        this.route( e )
        break
      case 'connect':
        if(this.navMenuIsOpen) {this.toggleNavMenu()}
        // this.isCurrentLocation = eventOwner
        this.route( e )
      break
      case 'charity':
        // console.log('charity')
        if(this.navMenuIsOpen) {this.toggleNavMenu()}
        // this.isCurrentLocation = eventOwner
        this.route( e )
      break
      case 'nav-back':
        history.back()
      break
      case 'fullscreen':
        this.toggleFullscreen()
      break
      case 'nav-menu':
        e.stopPropagation()
        this.toggleNavMenu()
        break
      case 'copy-contract-adr':
        textContent = 'zZRRHGndBuUsbn4VM47RuagdYt57hBbskQ2Ba6K5775'
        navigator.clipboard.writeText( textContent )
        break
      case 'copy-charity-adr':
        textContent = 'APSEqYjPo8fv8MKJHSkJmSqQL1M4uEiWrHx6v2HDKNiV'
        navigator.clipboard.writeText( textContent )
        break
      case 'lightbox-next':
        if(this.scene.memes.length - 1 === this.scene.memeNumber) {
          this.scene.memeNumber = 0
        } else {
          this.scene.memeNumber++
        }
        this.scene.changeLightboxImage()
        break
      case 'lightbox-previous':
        if(this.scene.memeNumber === 0) {
          this.scene.memeNumber = this.scene.memes.length - 1
        } else {
          this.scene.memeNumber--
        }
        this.scene.changeLightboxImage()
        // console.log('previous')
        break
    }
  }
  route( event ) {
    event = event || window.event; // get window.event if event argument not provided
    event.preventDefault()
    // window.history.pushState(state, unused, target link);
    window.history.pushState({}, "", event.target.href)
    this.locationHandler()
  }
  async locationHandler() {
        var location = window.location.hash.replace( '#', '/') // get the url path
        // if the path length is 0, set it to primary page route
        const btn = document.querySelector('.btn-back')
        // location.length === 0 ? btn.classList.add('display-none') : btn.classList.remove('display-none')
        if (location.length == 0) {
            location = "/";
        }
        // console.log('location', location)
        // get the route object from the urlRoutes object
        const route = this.routes[location] || this.routes["/"]
        // get the html from the template
        const html = route.html
        // console.log(html)
        //set scroll position
        window.scrollTo(0, 0)
        // set the content of the content div to the html
        document.querySelector('.app main').innerHTML = html
        this.addEventListeners()
        if(location === '/') {
          if(this.priceAndBalance.greg_usdc === undefined) {
            return
          } else {
            document.querySelector('.greg-usdc').textContent = this.priceAndBalance.greg_usdc
            document.querySelector('.greg-sol').textContent = this.priceAndBalance.greg_sol
          }
        } else if(location === '/charity') {
          // console.log(this.priceAndBalance)
            if(this.priceAndBalance === null || this.priceAndBalance.charityWalletBalance === null) {
              return
            } else {
              document.querySelector('.charity-balance').textContent = '$ ' + this.priceAndBalance.charityWalletBalance.toFixed(2)
            }
          }
        if(location.length > 1) {
          switch(location.substring(1)) {
            case 'about':
            case 'connect':
            case 'charity':
            case 'whitepaper':
            case 'memes':
              // console.log(location.substring(1))
              const element = document.querySelector('picture img')
              // console.log('element', element)
              element.setAttribute('src', this.contentImages[location.substring(1)].img)
            }
          }
        //link image blobs to injected divs
        // set the title of the document to the title of the route
        document.title = route.title

  }
  toggleFullscreen() {
    if(document.querySelector('html').getAttribute('data-fullscreen') === 'false')
    {
        document.querySelector('html').requestFullscreen()
        document.querySelector('html').setAttribute('data-fullscreen', true)
    }
    else
    {
        document.exitFullscreen()
        document.querySelector('html').setAttribute('data-fullscreen', false)
    }
  }
  toggleBackBtn(task) {
    const btn = document.querySelector('.btn-back')
    // console.log(btn)
    if(task !== 'hide') {
      // console.log('show')
      
    } else {
      console.log('hide')
      
    }
  } 
}

const app = new Structure()